<!-- HeaderPage.vue -->
<!-- 두번째 수정 시작 -->
<template>
  <v-app>
    <v-app-bar
      id="header"
      elevation="0"
      height="60"
      border
      class="bg-color-custom"
      :class="mobile ? 'mobile-header' : ''"
      style="z-index: 1000;"
      permanent
    >
      <div class="header-wrap">
        <!-- LEFT: 메뉴 + 로고 -->
        <div
          class="header-left"
          :class="userMobileStore.uiVisible.header.logoButton ? '' : 'without-logo-button'"
        >
          <!-- 메뉴 아이콘 -->
          <!-- 반응형 관련 : plugins/vuetify.js의 display/thresholds에서 breakpoint 정의. -->
          <v-app-bar-nav-icon
            v-if="userMobileStore.uiVisible.leftSidebar.sidebar"
            class="ms-4"
            :ripple="false"
            style="margin-inline-start:0 !important; width: 60px;"
            @click.stop="drawerControl();"
          />
          <!-- 언론사 로고 -->
          <v-img
            v-if="userMobileStore.uiVisible.header.logoButton"
            class="ms-5 header-logo"
            style="cursor: pointer;"
            :src="logoUrl"
            max-height="40"
            max-width="100"
            @click="openNewSite()"
          />
        </div>

        <!-- CENTER: (PC만) 캘린더를 가운데 -->
        <div
          v-if="!mobile"
          class="header-center"
        >
          <!-- 캘린더 -->
          <div v-if="userMobileStore.uiVisible.header.calendarButton">
            <v-menu
              v-model="openCalendarYn"
              :close-on-content-click="false"
              :disabled="isCalendarMenuBlocked"
              location="bottom center"
              :offset="8"
              width="350"
              min-width="0"
              :max-width="`${90*vw}`"
            >
              <template #activator="{ props }">
                <v-tooltip
                  location="bottom"
                  transition="null"
                  opacity="0"
                  offset="3"
                  :width="(isPageLoading && pageLoadingType !== 'date') ? 220 : 85"
                  :disabled="(!isPageLoading && openCalendarYn) || (!isPageLoading && userJS.isHandheldDevice())"
                >
                  <template #activator="{ props: tooltip }">
                    <v-btn
                      id="calendarBtn"
                      rounded="xl"
                      variant="text"
                      :ripple="false"
                      v-bind="mergeProps(props, tooltip)"
                      :aria-disabled="isPageLoading ? 'true' : 'false'"
                      :class="[
                        'calendar-btn-fixed',
                        userMobileStore.header.calendarButtonSubKey !== 'ICON' ? 'not-only-icon' : 'only-icon',
                        { 'btn-click-blocked': isPageLoading }
                      ]"
                      :style="isPageLoading ? { opacity: '0.6' } : {}"
                    >
                      <v-progress-circular
                        v-show="isPageLoading && pageLoadingType === 'date'"
                        indeterminate
                        size="18"
                        width="2"
                        color="primary"
                        class="calendar-btn-spinner"
                      />

                      <span
                        class="calendar-btn-content"
                        :class="{ 'calendar-btn-content-hidden': isPageLoading && pageLoadingType === 'date' }"
                      >
                        <p
                          v-if="userMobileStore.header.isCalendarTextVisible"
                          v-text="datepicker.format('yyyy-MM-dd (E)')"
                        />
                        <v-icon
                          v-if="userMobileStore.header.isCalendarIconVisible"
                          class="ms-1"
                          size="large"
                        >
                          mdi-calendar-blank
                        </v-icon>
                      </span>
                    </v-btn>
                  </template>

                  <!-- 툴팁 내용 -->
                  <div class="text-caption d-flex align-center">
                    {{ isPageLoading ? pageLoadingMessage : '날짜 선택하기' }}
                  </div>
                </v-tooltip>
              </template>
              <v-card
                style="border: solid 1px #E0E0E0; position:relative;"
                width="350"
                min-width="0"
                :max-width="`${90*vw}`"
                class="px-2 pt-2 pb-5"
                variant="outlined"
                elevation="0"
              >
                <!-- show-adjacent-months 속성 : 현재 달 앞 뒤 날짜 보이기 -->
                <v-date-picker
                  id="calendar"
                  v-model="datepicker"
                  :allowed-dates="allowedDates"
                  class="mx-auto"
                  :hide-header="true"
                  title="달력"
                  :to-date="calendarBrowseDate"
                  :min="minDate()"
                  :max="maxDate()"
                  @update:year="onYearChange"
                  @update:modelValue="handleDateClick"
                />
                <v-btn
                  class="px-0 custom-today-btn"
                  variant="outlined"
                  elevation="0"
                  @click="datepicker = new Date();"
                >
                  오늘
                </v-btn>
              </v-card>
            </v-menu>
          </div>
        </div>

        <!-- 모바일 dateSelectBox 중앙 배치 -->
        <div
          v-if="mobile && userMobileStore.uiVisible.header.dateSelectBox"
          class="date-select-box-wrap"
        >
          <!-- 년 -->
          <div class="date-select-item">
            <v-select
              v-model="selectedYear"
              :items="yearSelectOptions"
              variant="outlined"
              density="compact"
              hide-details
              class="date-select-box year-select-box"
              :menu-props="{ contentClass: 'year-select-menu' }"
              :disabled="isDateSelectLoading || (isPageLoading && pageLoadingType === 'media')"
              @update:model-value="handleYearSelectChange"
              @update:menu="(open) => open && scrollToSelected('.year-select-menu')"
            >
              <template #selection="{ item }">
                <v-progress-circular
                  v-if="isDateSelectLoading"
                  indeterminate
                  size="14"
                  width="2"
                  color="primary"
                />
                <span v-else>{{ item.title }}</span>
              </template>
            </v-select>
            <span class="date-select-suffix">년</span>
          </div>

          <!-- 월 -->
          <div class="date-select-item">
            <v-select
              v-model="selectedMonth"
              :items="monthSelectOptions"
              variant="outlined"
              density="compact"
              hide-details
              no-data-text="해당 년도에 선택할 수 있는 발행 월이 없습니다"
              class="date-select-box month-select-box"
              :menu-props="{ contentClass: 'month-select-menu' }"
              :disabled="isDateSelectLoading || (isPageLoading && pageLoadingType === 'media')"
              @update:model-value="handleMonthSelectChange"
              @update:menu="(open) => open && scrollToSelected('.month-select-menu')"
            >
              <template #selection="{ item }">
                <v-progress-circular
                  v-if="isDateSelectLoading"
                  indeterminate
                  size="14"
                  width="2"
                  color="primary"
                />
                <span v-else>{{ item.title }}</span>
              </template>
            </v-select>
            <span class="date-select-suffix">월</span>
          </div>

          <!-- 일 -->
          <div class="date-select-item">
            <v-select
              v-model="selectedDay"
              :items="daySelectOptions"
              variant="outlined"
              density="compact"
              hide-details
              no-data-text="해당 월에 선택할 수 있는 발행 일이 없습니다"
              class="date-select-box day-select-box"
              :menu-props="{ contentClass: 'day-select-menu' }"
              :disabled="isDateSelectLoading || (isPageLoading && pageLoadingType === 'media')"
              @update:model-value="handleDaySelectChange"
              @update:menu="(open) => open && scrollToSelected('.day-select-menu')"
            >
              <template #selection="{ item }">
                <v-progress-circular
                  v-if="isDateSelectLoading"
                  indeterminate
                  size="14"
                  width="2"
                  color="primary"
                />
                <span v-else>{{ item.title }}</span>
              </template>
            </v-select>
            <span class="date-select-suffix">일</span>
          </div>

          <!-- 면 -->
          <div class="date-select-item date-select-page-item">
            <v-select
              v-model="selectedPageIndex"
              :items="pageSelectOptions"
              variant="outlined"
              density="compact"
              hide-details
              class="date-select-box page-select-box"
              :menu-props="{ contentClass: 'page-select-menu' }"
              :disabled="isDateSelectLoading || (isPageLoading && pageLoadingType === 'media')"
              @update:menu="(open) => open && scrollToSelected('.page-select-menu')"
            >
              <template #selection="{ item }">
                <v-progress-circular
                  v-if="isDateSelectLoading"
                  indeterminate
                  size="14"
                  width="2"
                  color="primary"
                />
                <span v-else>{{ item.title }}</span>
              </template>
            </v-select>
            <span class="date-select-suffix">면</span>
          </div>
        </div>

        <!-- RIGHT: (모바일은 캘린더도 여기) + 나머지 버튼들 -->
        <div
          class="header-right"
          :class="userMobileStore.uiVisible.header.logoButton ? '' : 'without-logo-button'"
        >
          <div v-if="mobile && userMobileStore.uiVisible.header.calendarButton">
            <v-menu
              v-model="openCalendarYn"
              :close-on-content-click="false"
              :disabled="isCalendarMenuBlocked"
              location="bottom center"
              :offset="8"
              width="350"
              min-width="0"
              :max-width="`${90*vw}`"
            >
              <template #activator="{ props }">
                <v-tooltip
                  location="bottom"
                  transition="null"
                  opacity="0"
                  offset="3"
                  :width="(isPageLoading && pageLoadingType !== 'date') ? 220 : 85"
                  :disabled="(!isPageLoading && openCalendarYn) || (!isPageLoading && userJS.isHandheldDevice())"
                >
                  <template #activator="{ props: tooltip }">
                    <v-btn
                      id="calendarBtn"
                      rounded="xl"
                      variant="text"
                      :ripple="false"
                      v-bind="mergeProps(props, tooltip)"
                      :aria-disabled="isPageLoading ? 'true' : 'false'"
                      :class="[
                        'calendar-btn-fixed',
                        userMobileStore.header.calendarButtonSubKey !== 'ICON' ? 'not-only-icon' : 'only-icon',
                        { 'btn-click-blocked': isPageLoading }
                      ]"
                      :style="isPageLoading ? { opacity: '0.6' } : {}"
                    >
                      <v-progress-circular
                        v-show="isPageLoading && pageLoadingType === 'date'"
                        indeterminate
                        size="18"
                        width="2"
                        color="primary"
                        class="calendar-btn-spinner"
                      />

                      <span
                        class="calendar-btn-content"
                        :class="{ 'calendar-btn-content-hidden': isPageLoading && pageLoadingType === 'date' }"
                      >
                        <p
                          v-if="userMobileStore.header.isCalendarTextVisible"
                          v-text="datepicker.format('yyyy-MM-dd (E)')"
                        />
                        <v-icon
                          v-if="userMobileStore.header.isCalendarIconVisible"
                          class="ms-1"
                          size="large"
                        >
                          mdi-calendar-blank
                        </v-icon>
                      </span>
                    </v-btn>
                  </template>
                  <!-- 툴팁 내용 -->
                  <div class="text-caption d-flex align-center">
                    {{ isPageLoading ? pageLoadingMessage : '날짜 선택하기' }}
                  </div>
                </v-tooltip>
              </template>
              <v-card
                style="border: solid 1px #E0E0E0; position:relative;"
                width="350"
                min-width="0"
                :max-width="`${90*vw}`"
                class="px-2 pt-2 pb-5"
                variant="outlined"
                elevation="0"
              >
                <!-- show-adjacent-months 속성 : 현재 달 앞 뒤 날짜 보이기 -->
                <v-date-picker
                  id="calendar"
                  v-model="datepicker"
                  :allowed-dates="allowedDates"
                  class="mx-auto"
                  :hide-header="true"
                  title="달력"
                  :to-date="calendarBrowseDate"
                  :min="minDate()"
                  :max="maxDate()"
                  @update:year="onYearChange"
                  @update:modelValue="handleDateClick"
                />
                <v-btn
                  class="px-0 custom-today-btn"
                  variant="outlined"
                  elevation="0"
                  @click="datepicker = new Date();"
                >
                  오늘
                </v-btn>
              </v-card>
            </v-menu>
          </div>

          <!-- 지면 자르기 버튼 -->
          <v-dialog
            v-if="userMobileStore.uiVisible.header.imageCutting && pageSide == 1"
            v-model="isCuttingOverlayOn"
            :width="'60%'"
            persistent
            no-click-animation
            eager
          >
            <template #activator="{ props: activatorProps }">
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="74"
                :disabled="userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <v-btn
                    id="cutPageBtn"
                    icon="mdi-content-cut"
                    :ripple="false"
                    variant="text"
                    v-bind="mergeProps(activatorProps, tooltip)"
                    @click="setCuttingCanvas();"
                  />
                </template>
                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  지면 자르기
                </div>
              </v-tooltip>
            </template>

            <v-card>
              <div class="d-flex align-center justify-space-between">
                <v-card-title class="px-0 cut-image-select-title">
                  지면 이미지 자르기
                </v-card-title>
                <!-- 닫기 버튼 -->
                <v-btn
                  icon="mdi-window-close"
                  :ripple="false"
                  elevation="0"
                  variant="tonal"
                  class="ma-0"
                  :height="40"
                  :width="40"
                  @click="userJS.cuttingCanvas_closeBtnfunc(); isCuttingOverlayOn = false;"
                />
              </div>

              <!-- 상단 영역 : 버튼 -->
              <v-card-actions>
                <v-btn-group
                  variant="flat"
                  divided
                  width="60%"
                  class="d-flex align-center"
                  :ripple="false"
                >
                  <v-btn
                    :color="selectedTool == 'alongLine' ? 'primary' : 'surface-variant'"
                    class="cutting-tool-btn"
                    :ripple="false"
                    prepend-icon="mdi-vector-polyline"
                    @click="setCuttingCanvas_alongLine();"
                  >
                    선 오리기
                  </v-btn>
                  <v-btn
                    :color="selectedTool == 'alongArea' ? 'primary' : 'surface-variant'"
                    class="cutting-tool-btn"
                    style="margin-left: 0px !important"
                    :ripple="false"
                    prepend-icon="mdi-vector-square"
                    @click="setCuttingCanvas_alongArea();"
                  >
                    면 오리기
                  </v-btn>
                </v-btn-group>

                <v-spacer />
                <v-btn
                  color="surface-variant"
                  variant="flat"
                  width="7%"
                  :ripple="false"
                  @click="userJS.cuttingCanvas_resetBtnfunc();"
                >
                  새로고침
                </v-btn>
              </v-card-actions>

              <!-- 본문 영역 : canvas -->
              <v-card
                class="mx-5"
                variant="outlined"
                style="border: 2px solid rgb(190, 190, 191); background-color: #212121; height: 100%; overflow-y: auto;"
              >
                <canvas
                  id="c"
                  style="display:block;"
                />
              </v-card>

              <!--하단 영역 : 버튼 -->
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="surface-variant"
                  variant="flat"
                  width="5%"
                  :ripple="false"
                  @click="userJS.cuttingCanvas_closeBtnfunc(); isCuttingOverlayOn = false;"
                >
                  닫기
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- 키워드 하이라이트 색상 변경 버튼 -->
          <div
            v-if="userMobileStore.uiVisible.header.highlightColorChange
              && userStore.$isOption(roleSelection, 'hilight')
              && isColorPickerActive
            "
            width="auto"
          >
            <v-tooltip
              location="bottom"
              transition="null"
              opacity="0"
              offset="7"
              width="106"
              :disabled="mobile || userJS.isHandheldDevice()"
            >
              <template #activator="{ props: tooltip }">
                <div style="position: relative; display: inline-block;">
                  <input
                    id="colorPicker-web"
                    ref="colorPickerInput"
                    type="color"
                    style="opacity: 0;"
                    :value="userStore.searchHiColor"
                    @change="updateColorAtCenterAndDetail"
                  >
                  <v-btn
                    id="colorPickerBtn-web"
                    icon="mdi-palette"
                    :color="userStore.searchHiColor"
                    :ripple="false"
                    v-bind="tooltip"
                  />
                </div>
              </template>

              <!-- 툴팁 내용 -->
              <div
                class="text-caption d-flex align-center"
              >
                키워드 하이라이트 색상 변경하기
              </div>
            </v-tooltip>
          </div>

          <!-- 저장하기 버튼 -->
          <v-dialog
            v-if="userMobileStore.uiVisible.header.imageDownload && userStore.$isOption(roleSelection, 'download')"
            width="auto"
          >
            <template #activator="{ props: activatorProps }">
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="120"
                :disabled="userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <v-btn
                    id="pageDownloadBtn"
                    icon="mdi-tray-arrow-down"
                    :ripple="false"
                    variant="text"
                    v-bind="mergeProps(activatorProps, tooltip)"
                    @click="setForSidePageTwo();"
                  />
                </template>

                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  지면 이미지 저장하기
                </div>
              </v-tooltip>
            </template>

            <template #default="{ isActive }">
              <v-card>
                <v-card-title class="download-image-select-title">
                  지면 이미지 저장
                </v-card-title>
                <!-- 양면일 때 -->
                <v-divider v-if="pageSide==2" />
                <v-card-text
                  v-if="pageSide==2"
                  class="px-4"
                >
                  <div class="v-card-title2">
                    페이지 선택
                  </div>
                  <v-radio-group
                    v-model="presentPageSerial"
                    hide-details
                    inline
                  >
                    <v-radio
                      :label="`${serialsForPrint[0].Serial.substring(12, 15)}면`"
                      :value="serialsForPrint[0].Serial"
                      :disabled="!allSerial.includes(serialsForPrint[0].Serial)"
                    />
                    <v-radio
                      v-if="serialsForPrint[1]"
                      class="ms-8"
                      :label="`${serialsForPrint[1]?.Serial.substring(12, 15)}면`"
                      :value="serialsForPrint[1].Serial"
                      :disabled="!allSerial.includes(serialsForPrint[1].Serial)"
                    />
                  </v-radio-group>
                </v-card-text>

                <v-card-text class="px-4">
                  <div class="v-card-title2">
                    저장 화질 선택
                  </div>
                  <v-radio-group
                    v-model="imageDownloadSelection"
                    hide-details
                  >
                    <v-radio
                      label="저화질"
                      value="low"
                    />
                    <v-radio
                      label="중화질"
                      value="medium"
                    />
                    <v-radio
                      label="고화질"
                      value="high"
                    />
                    <v-radio
                      label="원본"
                      value="original"
                    />
                  </v-radio-group>
                </v-card-text>

                <v-card-actions>
                  <v-btn
                    color="surface-variant"
                    variant="flat"
                    @click="isActive.value = false;"
                  >
                    닫기
                  </v-btn>

                  <v-spacer />

                  <v-btn
                    color="primary"
                    variant="flat"
                    :disabled="presentPageSerial==''"
                    @click="if(imageDownloadSelection != '') {downloadNewsImage(); isActive.value = false;}"
                  >
                    저장
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>

          <!-- 지면 이미지 인쇄 버튼 -->
          <v-dialog
            v-if="!mobile"
            width="auto"
          >
            <template #activator="{ props: activatorProps }">
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="120"
                :disabled="userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <v-btn
                    id="printPageBtn"
                    icon="mdi-printer"
                    :ripple="false"
                    variant="text"
                    v-bind="mergeProps(activatorProps, tooltip)"
                    @click="setForSidePageTwo();"
                  />
                </template>

                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  지면 이미지 인쇄하기
                </div>
              </v-tooltip>
            </template>
            <template #default="{ isActive }">
              <v-card>
                <v-card-title class="download-image-select-title">
                  지면 이미지 인쇄
                </v-card-title>
                <!-- 양면일 때 -->
                <v-divider v-if="pageSide==2" />
                <v-card-text
                  v-if="pageSide==2"
                  class="px-4"
                >
                  <div class="v-card-title2">
                    페이지 선택
                  </div>
                  <v-radio-group
                    v-model="presentPageSerial"
                    hide-details
                    inline
                  >
                    <v-radio
                      :label="`${serialsForPrint[0].Serial.substring(12, 15)}면`"
                      :value="serialsForPrint[0].Serial"
                      :disabled="!allSerial.includes(serialsForPrint[0].Serial)"
                    />
                    <v-radio
                      v-if="serialsForPrint[1]"
                      class="ms-8"
                      :label="`${serialsForPrint[1]?.Serial.substring(12, 15)}면`"
                      :value="serialsForPrint[1].Serial"
                      :disabled="!allSerial.includes(serialsForPrint[1].Serial)"
                    />
                  </v-radio-group>
                </v-card-text>

                <v-card-text class="px-4">
                  <div class="v-card-title2">
                    인쇄 화질 선택
                  </div>
                  <v-radio-group
                    v-model="imagePrintSelection"
                    hide-details
                  >
                    <v-radio
                      label="저화질"
                      value="low"
                    />
                    <v-radio
                      label="중화질"
                      value="medium"
                    />
                    <v-radio
                      label="고화질"
                      value="high"
                    />
                    <v-radio
                      label="원본"
                      value="original"
                    />
                  </v-radio-group>
                </v-card-text>

                <v-card-actions>
                  <v-btn
                    color="surface-variant"
                    variant="flat"
                    @click="isActive.value = false;"
                  >
                    닫기
                  </v-btn>

                  <v-spacer />

                  <v-btn
                    color="primary"
                    variant="flat"
                    :disabled="presentPageSerial==''"
                    @click="if(imagePrintSelection != '') {printPage(); isActive.value = false;}"
                  >
                    인쇄
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>

          <!-- tts 버튼 -->
          <input
            id="endAudio"
            type="hidden"
            @click="isEnd = true; isPaused = true;"
          >
          <input
            id="nextAudio"
            type="hidden"
            @click="goArticlePage_Auto()"
          >
          <v-menu
            v-if="userMobileStore.uiVisible.header.tts && userStore.$isOption(roleSelection, 'tts')"
            v-model="ttsMenu"
            :close-on-content-click="false"
            :no-click-animation="true"
            location="bottom center"
            :offset="12"
            width="300"
            min-width="0"
            :max-width="`${80*vw}`"
            :max-height="`${70*vh}`"
          >
            <template #activator="{ props: volumeSliderProps}">
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                :width="art != null ? '180' : '65'"
                :disabled="ttsMenu || userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <v-btn
                    icon="mdi-volume-high"
                    :ripple="false"
                    :class="{ttsOn : !isEnd && !isPaused}"
                    :variant="isPaused ? 'text' : 'tonal'"
                    :color="isPaused ? 'black' : 'primary'"
                    v-bind="mergeProps(volumeSliderProps, tooltip)"
                  />
                </template>

                <!-- 툴팁 내용 -->
                <div class="marquee">
                  <!-- art.imgType : 자른 지면 스크랩 여부 -->
                  <div
                    v-if="art != null && ttsLoadingSuccess"
                    class="text-caption d-flex align-center"
                    :class="{'marquee-content' : art.imgType || (!isEnd && !isPaused)}"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  >
                    {{ ttsArticleTitle }}
                  </div>
                  <div
                    v-else-if="art == null"
                    class="text-caption text-center"
                  >
                    <!-- <div>{{navigator.userAgent}}</div> -->
                    음성 듣기
                  </div>
                  <!-- tts 로딩 중 -->
                  <div
                    v-else
                    class="text-caption text-center"
                  >
                    로딩 중입니다...
                  </div>
                </div>
              </v-tooltip>
            </template>
            <v-card
              class="pa-2"
              variant="outlined"
              elevation="0"
              width="300"
              min-width="0"
              :max-width="`${90*vw}`"
              :max-height="`${70*vh}`"
              style="border: solid 1px rgb(224, 224, 224); overflow-y: scroll;"
            >
              <!-- tts player -->
              <v-card
                class="px-4 pt-4 ma-0"
                style="border: solid 1px #E0E0E0; padding:20px;"
                elevation="0"
              >
                <div
                  v-if="art != null && ttsLoadingSuccess"
                  class="text-caption mx-2"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-height: 20px;"
                >
                  {{ ttsArticleTitle }}
                </div>
                <div
                  v-else-if="art == null"
                  class="text-caption text-center mx-2"
                  style="min-height: 20px;"
                >
                  아래 실행 버튼을 눌러주세요.
                </div>
                <!-- tts 로딩 중 -->
                <div
                  v-else
                  class="text-caption mx-2"
                  style="min-height: 20px;"
                >
                  로딩 중입니다...
                </div>

                <!-- tts 로딩 중 -->
                <div
                  class="mx-2"
                  :style="{
                    width: !ttsLoadingSuccess ? '95%' : '0px',
                    height: !ttsLoadingSuccess ? 'unset' : '0px',
                    padding: !ttsLoadingSuccess ? '14px 0px 14px' : '0px',
                  }"
                >
                  <v-progress-linear
                    color="amber"
                    indeterminate
                    rounded
                    style="height: 4px;"
                  />
                </div>

                <v-slider
                  v-model="progress"
                  color="primary"
                  track-color="grey"
                  :ripple="false"
                  :max="100"
                  class="no-thumb"
                  :readonly="isEnd"
                  thumb-size="0"
                  hide-details
                  :style="{
                    width: ttsLoadingSuccess ? '90%' : '0px',
                    height: ttsLoadingSuccess ? 'unset' : '0px',
                  }"
                  @mousedown="startDragging()"
                  @mouseup="onDragging()"
                  @mouseleave="onDragging()"
                  @touchstart="startDragging()"
                  @touchend="onDragging()"
                  @touchcancel="onDragging()"
                />
                <div class="d-flex justify-between mx-2">
                  <div class="text-caption">
                    {{ currentTimeTts }}
                  </div>
                  <v-spacer />
                  <div class="text-caption">
                    {{ durationTts }}
                  </div>
                </div>
                <v-card-actions class="d-flex justify-center pa-0">
                  <!-- 이전 버튼 -->
                  <v-btn
                    id="prev-tts-btn"
                    icon
                    variant="text"
                    :disabled="isCuttingScrap"
                    @click="playerPrevBtn();"
                  >
                    <v-icon class="icon-reverse">
                      mdi-play-pause
                    </v-icon>
                  </v-btn>
                  <!-- 첫 실행, 멈춤/재실행 버튼 -->
                  <v-btn
                    id="start-tts-btn"
                    :icon="isPaused ? 'mdi-play' : 'mdi-pause'"
                    variant="text"
                    style="border: 1px #ccc solid;"
                    :disabled="isCuttingScrap"
                    @click="ttsPlay();"
                  />
                  <!-- 다음 버튼 -->
                  <v-btn
                    id="next-tts-btn"
                    icon
                    variant="text"
                    :disabled="isCuttingScrap"
                    @click="goArticlePage_Manual();"
                  >
                    <v-icon>mdi-play-pause</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>

              <v-list>
                <v-list-item>
                  <div class="font-weight-bold">
                    볼륨 조정
                  </div>
                  <div
                    style="width: 95%"
                    class="py-4"
                  >
                    <v-slider
                      v-model="audioOption.volume"
                      track-color="primary"
                      prepend-icon="mdi-volume-high"
                      thumb-label="always"
                      thumb-size="10"
                      :max="100"
                      :min="0"
                      :step="1"
                      hide-details
                    />
                  </div>
                </v-list-item>

                <v-list-item>
                  <div class="font-weight-bold">
                    재생 속도
                  </div>
                  <!-- <div class="d-flex justify-space-around align-center py-4">
                  <v-radio-group inline color="primary" :hide-details="true" :ripple="false" v-model="audioOption.speed">
                    <v-radio label="느림" :value="0.7"></v-radio>
                    <v-radio label="보통" :value="1"></v-radio>
                    <v-radio label="빠름" :value="1.5"></v-radio>
                  </v-radio-group>
                </div> -->
                  <div
                    style="width: 95%"
                    class="py-4"
                  >
                    <v-slider
                      v-model="audioOption.speed"
                      track-color="primary"
                      prepend-icon="mdi-play-speed"
                      thumb-label="always"
                      thumb-size="10"
                      :max="3"
                      :min="0.5"
                      :step="0.1"
                      hide-details
                    >
                      <template #thumb-label="{ modelValue }">
                        x{{ modelValue }}
                      </template>
                    </v-slider>
                  </div>
                </v-list-item>

                <v-list-item>
                  <div class="font-weight-bold">
                    목소리
                  </div>
                  <div class="d-flex justify-space-around align-center pt-4">
                    <v-radio-group
                      v-model="audioOption.voice"
                      inline
                      color="primary"
                      :hide-details="true"
                      :ripple="false"
                    >
                      <v-radio
                        label="여자1"
                        :value="'ko-KR-Standard-B'"
                      />
                      <v-radio
                        label="여자2"
                        :value="'ko-KR-Standard-A'"
                      />
                      <v-radio
                        label="남자1"
                        :value="'ko-KR-Standard-C'"
                      />
                      <v-radio
                        label="남자2"
                        :value="'ko-KR-Standard-D'"
                      />
                    </v-radio-group>
                  </div>
                </v-list-item>

                <!-- 띄어쓰기 자동보정 기능 비활성화(-) -->
                <div class="d-flex align-center px-4">
                  <div class="font-weight-bold">
                    띄어쓰기 자동 보정
                  </div>
                  <v-switch
                    v-model="audioOption.correctSpace"
                    class="ffont-weight-bold px-4"
                    inset
                    color="primary"
                    hide-details
                  />
                </div>

                <div class="d-flex align-center px-4">
                  <div class="font-weight-bold">
                    다음기사 자동 재생
                    <p
                      class="text-caption"
                      style="color: rgb(142, 142, 142);"
                    >
                      * 북마크 기사는 다음기사 자동 재생 기능이 지원되지 않습니다.
                    </p>
                  </div>
                  <v-switch
                    v-model="audioOption.ttsAutoPlay"
                    class="ffont-weight-bold px-4"
                    inset
                    color="primary"
                    hide-details
                  />
                </div>
              </v-list>
            </v-card>
          </v-menu>

          <div v-if="!mobile">
            <!-- 양/단면 버튼 -->
            <v-tooltip
              location="bottom"
              transition="null"
              opacity="0"
              offset="7"
              width="110"
            >
              <template #activator="{ props: tooltip }">
                <v-btn
                  icon="mdi-cog"
                  :ripple="false"
                  variant="text"
                  v-bind="tooltip"
                  @click="setupFunc.togglePageSideOption();"
                >
                  <span
                    v-if="pageSide === 1"
                    class="material-symbols-outlined pageSideBtn"
                  >view_array</span>
                  <span
                    v-else
                    class="material-symbols-outlined pageSideBtn"
                  >two_pager</span>
                </v-btn>
              </template>

              <!-- 툴팁 내용 -->
              <div class="text-caption d-flex align-center">
                양면/단면 변경하기
              </div>
            </v-tooltip>
          </div>

          <!-- 화면 최대화 버튼. ios에서는 관련 fullscreen API를 지원하지 않으므로 최대화 버튼 안 보이도록! -->
          <div v-if="userMobileStore.uiVisible.header.backgroundMaximize && userJS.checkMobile() != 'ios'">
            <v-tooltip
              location="bottom"
              transition="null"
              opacity="0"
              offset="7"
              width="95"
              :disabled="userJS.isHandheldDevice()"
            >
              <template #activator="{ props: tooltip }">
                <v-btn
                  id="alignmentControlBtn"
                  icon="mdi-overscan"
                  :ripple="false"
                  variant="text"
                  v-bind="tooltip"
                  @click="onClickFullScreen"
                />
              </template>

              <!-- 툴팁 내용 -->
              <div
                class="text-caption d-flex align-center"
              >
                화면 최대화하기
              </div>
            </v-tooltip>
          </div>

          <!-- 기능 더보기 버튼(케밥 버튼) : 지면 다운로드, 하이라이트 색상 변경하기, 지면 자르기 버튼 -->
          <v-menu
            v-if="userMobileStore.uiVisible.header.hamburgerButton"
            id="moreFuncBtnMenu"
            v-model="moreFuncYn"
            :close-on-content-click="false"
            location="bottom center"
            :offset="8"
            width="44"
            min-width=""
            max-width="44"
            transition="slide-y-transition"
            style="background-color: transparent; border: none; overflow-x: hidden !important;"
          >
            <template #activator="{ props }">
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="1"
                width="74"
                :disabled="moreFuncYn || userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <v-btn
                    id="moreFuncBtn"
                    icon="mdi-dots-vertical"
                    :ripple="false"
                    variant="text"
                    v-bind="mergeProps(props, tooltip)"
                  />
                </template>
                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  기능 더보기
                </div>
              </v-tooltip>
            </template>

            <v-card
              style="background-color: transparent; border: none; overflow-x: hidden !important;"
              class="pa-2"
              width="52"
              min-width=""
              max-width="52"
              variant="outlined"
              elevation="0"
            >
              <!-- hamburgerButton.items 순서대로 렌더링 -->
              <div
                v-for="item in userMobileStore.header.$hamburgerButtonVisibleItems(mobile)"
                :key="item.key"
              >
                <!-- 1) 모바일 저장하기 버튼 -->
                <v-dialog
                  v-if="
                    item.key === 'imageDownload'
                      && userMobileStore.uiVisible.header.imageDownloadInHamburger
                      && userStore.$isOption(roleSelection, 'download')
                  "
                  width="auto"
                >
                  <template #activator="{ props: activatorProps }">
                    <v-tooltip
                      location="left"
                      transition="null"
                      opacity="0"
                      offset="1"
                      width="120"
                      :disabled="userJS.isHandheldDevice()"
                    >
                      <template #activator="{ props: tooltip }">
                        <button
                          id="pageDownloadBtn-mobile"
                          class="mb-1"
                          v-bind="mergeProps(activatorProps, tooltip)"
                          @click="setForSidePageTwo()"
                        >
                          <i class="kebab mdi mdi-tray-arrow-down" />
                        </button>
                      </template>

                      <!-- 툴팁 내용 -->
                      <div class="text-caption d-flex align-center">
                        지면 이미지 저장하기
                      </div>
                    </v-tooltip>
                  </template>

                  <template #default="{ isActive }">
                    <v-card>
                      <v-card-title class="download-image-select-title">
                        지면 이미지 저장
                      </v-card-title>
                      <!-- 양면일 때 -->
                      <v-divider v-if="pageSide==2" />
                      <v-card-text
                        v-if="pageSide==2"
                        class="px-4"
                      >
                        <div class="v-card-title2">
                          페이지 선택
                        </div>
                        <v-radio-group
                          v-model="presentPageSerial"
                          hide-details
                          inline
                        >
                          <v-radio
                            :label="`${serialsForPrint[0].Serial.substring(12, 15)}면`"
                            :value="serialsForPrint[0].Serial"
                            :disabled="!allSerial.includes(serialsForPrint[0].Serial)"
                          />
                          <v-radio
                            v-if="serialsForPrint[1]"
                            class="ms-8"
                            :label="`${serialsForPrint[1]?.Serial.substring(12, 15)}면`"
                            :value="serialsForPrint[1].Serial"
                            :disabled="!allSerial.includes(serialsForPrint[1].Serial)"
                          />
                        </v-radio-group>
                      </v-card-text>

                      <v-card-text class="px-4">
                        <div class="v-card-title2">
                          저장 화질 선택
                        </div>
                        <v-radio-group
                          v-model="imageDownloadSelection"
                          hide-details
                        >
                          <v-radio
                            label="저화질"
                            value="low"
                          />
                          <v-radio
                            label="중화질"
                            value="medium"
                          />
                          <v-radio
                            label="고화질"
                            value="high"
                          />
                          <v-radio
                            label="원본"
                            value="original"
                          />
                        </v-radio-group>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn
                          color="surface-variant"
                          variant="flat"
                          @click="isActive.value = false;"
                        >
                          닫기
                        </v-btn>

                        <v-spacer />

                        <v-btn
                          color="primary"
                          variant="flat"
                          :disabled="presentPageSerial==''"
                          @click="if(imageDownloadSelection != '') {downloadNewsImage(); isActive.value = false;}"
                        >
                          저장
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <!-- 2) 모바일 지면 자르기 버튼 -->
                <v-dialog
                  v-else-if="
                    item.key === 'imageCutting'
                      && userMobileStore.uiVisible.header.imageCuttingInHamburger
                      && pageSide == 1
                  "
                  v-model="isCuttingMobileOverlayOn"
                  persistent
                  no-click-animation
                  fullscreen
                  :width="'100%'"
                  :max-width="'100%'"
                  eager
                >
                  <template #activator="{ props: activatorProps }">
                    <v-tooltip
                      location="left"
                      offset="1"
                      transition="null"
                      opacity="0"
                      width="74"
                      :disabled="userJS.isHandheldDevice()"
                    >
                      <template #activator="{ props: tooltip }">
                        <button
                          id="pageCuttingBtn-mobile"
                          class="mb-1"
                          v-bind="mergeProps(activatorProps, tooltip)"
                          @click="setCuttingCanvas()"
                        >
                          <i class="kebab mdi mdi-content-cut" />
                        </button>
                      </template>
                      <!-- 툴팁 내용 -->
                      <div
                        class="text-caption d-flex align-center"
                      >
                        지면 자르기
                      </div>
                    </v-tooltip>
                  </template>

                  <v-card style="height: 100%;">
                    <div class="d-flex align-center justify-space-between">
                      <v-card-title class="px-0 cut-image-select-title">
                        지면 이미지 자르기
                      </v-card-title>
                      <!-- 닫기 버튼 -->
                      <v-btn
                        icon="mdi-window-close"
                        :ripple="false"
                        elevation="0"
                        variant="tonal"
                        class="ma-0"
                        :height="40"
                        :width="40"
                        @click="userJS.cuttingCanvas_closeBtnfunc(); isCuttingMobileOverlayOn = false;"
                      />
                    </div>
                    <div
                      class="pt-0 d-flex flex-column justify-space-between"
                      style="height: calc(100% - 52px);"
                    >
                      <!-- 상단 영역 : 버튼 -->
                      <v-card-actions class="pa-0">
                        <v-btn-group
                          variant="flat"
                          divided
                          width="60%"
                          class="d-flex align-center"
                          :ripple="false"
                        >
                          <v-btn
                            :color="selectedTool == 'alongLine' ? 'primary' : 'surface-variant'"
                            class="cutting-tool-btn"
                            :ripple="false"
                            prepend-icon="mdi-vector-polyline"
                            @click="setCuttingCanvas_alongLine();"
                          >
                            선 오리기
                          </v-btn>
                          <v-btn
                            :color="selectedTool == 'alongArea' ? 'primary' : 'surface-variant'"
                            class="cutting-tool-btn"
                            style="margin-left: 0px !important;"
                            :ripple="false"
                            prepend-icon="mdi-vector-square"
                            @click="setCuttingCanvas_alongArea();"
                          >
                            면 오리기
                          </v-btn>
                        </v-btn-group>
                        <v-spacer />
                        <v-btn
                          color="surface-variant"
                          variant="flat"
                          width="7%"
                          @click="userJS.cuttingCanvas_resetBtnfunc();"
                        >
                          새로고침
                        </v-btn>
                      </v-card-actions>

                      <!-- 본문 영역 : canvas -->
                      <v-card
                        id="mobileCuttingCanvasBorder"
                        class="pa-0"
                        variant="outlined"
                        style="border: 2px solid rgb(190, 190, 191); overflow-y: hidden;"
                      >
                        <canvas
                          id="c"
                          style="display:block; width: 100%;"
                        />
                      </v-card>

                      <!--하단 영역 : 버튼 -->
                      <v-card-actions class="pa-0">
                        <v-spacer />
                        <v-btn
                          color="surface-variant"
                          variant="flat"
                          width="5%"
                          @click="userJS.cuttingCanvas_closeBtnfunc(); isCuttingMobileOverlayOn = false;"
                        >
                          닫기
                        </v-btn>
                      </v-card-actions>
                    </div>
                  </v-card>
                </v-dialog>

                <!-- 3) 모바일 검색 키워드 하이라이트 색상 변경 버튼 -->
                <div
                  v-else-if="
                    item.key === 'highlightColorChange'
                      && userMobileStore.uiVisible.header.highlightColorChangeInHamburger
                      && userStore.$isOption(roleSelection, 'hilight')
                      && isColorPickerActive
                  "
                  style="position: relative; display: inline-block; height: 36px; width: 36px; margin-bottom: -4px;"
                >
                  <input
                    id="colorPicker-mobile"
                    ref="colorPickerInput"
                    type="color"
                    style="opacity: 0;"
                    :value="userStore.searchHiColor"
                    @change="updateColorAtCenterAndDetail"
                  >
                  <v-tooltip
                    location="left"
                    transition="null"
                    opacity="0"
                    offset="1"
                    width="106"
                    :disabled="userJS.isHandheldDevice()"
                  >
                    <template #activator="{ props: tooltip }">
                      <button
                        id="colorPickerBtn-mobile"
                        :style="{ backgroundColor: userStore.searchHiColor }"
                        style="border: none; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center;"
                        v-bind="tooltip"
                        @click="if(colorPickerInput) colorPickerInput.click();"
                      >
                        <i class="kebab mdi mdi-palette" />
                      </button>
                    </template>

                    <!-- 툴팁 내용 -->
                    <div
                      class="text-caption d-flex align-center"
                    >
                      키워드 하이라이트 색상 변경하기
                    </div>
                  </v-tooltip>
                </div>

                <!-- 4) TTS 버튼 (햄버거 내부용) -->
                <v-menu
                  v-else-if="
                    item.key === 'tts'
                      && userMobileStore.uiVisible.header.ttsInHamburger
                      && userStore.$isOption(roleSelection, 'tts')
                  "
                  v-model="ttsMenu"
                  :close-on-content-click="false"
                  :no-click-animation="true"
                  location="left center"
                  :offset="8"
                  width="300"
                  min-width="0"
                  :max-width="`${80*vw}`"
                  :max-height="`${70*vh}`"
                >
                  <template #activator="{ props: volumeSliderProps}">
                    <v-tooltip
                      location="left"
                      transition="null"
                      opacity="0"
                      offset="1"
                      :width="art != null ? '180' : '65'"
                      :disabled="ttsMenu || userJS.isHandheldDevice()"
                    >
                      <template #activator="{ props: tooltip }">
                        <button
                          id="ttsBtn-mobile"
                          class="mb-1"
                          :class="{ttsOn : !isEnd && !isPaused}"
                          v-bind="mergeProps(volumeSliderProps, tooltip)"
                        >
                          <i class="kebab mdi mdi-volume-high" />
                        </button>
                      </template>

                      <!-- 툴팁 내용 -->
                      <div class="marquee">
                        <div
                          v-if="art != null && ttsLoadingSuccess"
                          class="text-caption d-flex align-center"
                          :class="{'marquee-content' : art.imgType || (!isEnd && !isPaused)}"
                          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        >
                          {{ ttsArticleTitle }}
                        </div>
                        <div
                          v-else-if="art == null"
                          class="text-caption text-center"
                        >
                          음성 듣기
                        </div>
                        <div
                          v-else
                          class="text-caption text-center"
                        >
                          로딩 중입니다...
                        </div>
                      </div>
                    </v-tooltip>
                  </template>

                  <!-- 아래 v-card 내부는 기존 tts 메뉴 내용 그대로 복붙 -->
                  <v-card
                    class="pa-2"
                    variant="outlined"
                    elevation="0"
                    width="300"
                    min-width="0"
                    :max-width="`${90*vw}`"
                    :max-height="`${70*vh}`"
                    style="border: solid 1px rgb(224, 224, 224); overflow-y: scroll;"
                  >
                    <!-- tts player -->
                    <v-card
                      class="px-4 pt-4 ma-0"
                      style="border: solid 1px #E0E0E0; padding:20px;"
                      elevation="0"
                    >
                      <div
                        v-if="art != null && ttsLoadingSuccess"
                        class="text-caption mx-2"
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-height: 20px;"
                      >
                        {{ ttsArticleTitle }}
                      </div>
                      <div
                        v-else-if="art == null"
                        class="text-caption text-center mx-2"
                        style="min-height: 20px;"
                      >
                        아래 실행 버튼을 눌러주세요.
                      </div>
                      <!-- tts 로딩 중 -->
                      <div
                        v-else
                        class="text-caption mx-2"
                        style="min-height: 20px;"
                      >
                        로딩 중입니다...
                      </div>

                      <!-- tts 로딩 중 -->
                      <div
                        class="mx-2"
                        :style="{
                          width: !ttsLoadingSuccess ? '95%' : '0px',
                          height: !ttsLoadingSuccess ? 'unset' : '0px',
                          padding: !ttsLoadingSuccess ? '14px 0px 14px' : '0px',
                        }"
                      >
                        <v-progress-linear
                          color="amber"
                          indeterminate
                          rounded
                          style="height: 4px;"
                        />
                      </div>

                      <v-slider
                        v-model="progress"
                        color="primary"
                        track-color="grey"
                        :ripple="false"
                        :max="100"
                        class="no-thumb"
                        :readonly="isEnd"
                        thumb-size="0"
                        hide-details
                        :style="{
                          width: ttsLoadingSuccess ? '90%' : '0px',
                          height: ttsLoadingSuccess ? 'unset' : '0px',
                        }"
                        @mousedown="startDragging()"
                        @mouseup="onDragging()"
                        @mouseleave="onDragging()"
                        @touchstart="startDragging()"
                        @touchend="onDragging()"
                        @touchcancel="onDragging()"
                      />
                      <div class="d-flex justify-between mx-2">
                        <div class="text-caption">
                          {{ currentTimeTts }}
                        </div>
                        <v-spacer />
                        <div class="text-caption">
                          {{ durationTts }}
                        </div>
                      </div>
                      <v-card-actions class="d-flex justify-center pa-0">
                        <!-- 이전 버튼 -->
                        <v-btn
                          id="prev-tts-btn"
                          icon
                          variant="text"
                          :disabled="isCuttingScrap"
                          @click="playerPrevBtn();"
                        >
                          <v-icon class="icon-reverse">
                            mdi-play-pause
                          </v-icon>
                        </v-btn>
                        <!-- 첫 실행, 멈춤/재실행 버튼 -->
                        <v-btn
                          id="start-tts-btn"
                          :icon="isPaused ? 'mdi-play' : 'mdi-pause'"
                          variant="text"
                          style="border: 1px #ccc solid;"
                          :disabled="isCuttingScrap"
                          @click="ttsPlay();"
                        />
                        <!-- 다음 버튼 -->
                        <v-btn
                          id="next-tts-btn"
                          icon
                          variant="text"
                          :disabled="isCuttingScrap"
                          @click="goArticlePage_Manual();"
                        >
                          <v-icon>mdi-play-pause</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>

                    <v-list>
                      <v-list-item>
                        <div class="font-weight-bold">
                          볼륨 조정
                        </div>
                        <div
                          style="width: 95%"
                          class="py-4"
                        >
                          <v-slider
                            v-model="audioOption.volume"
                            track-color="primary"
                            prepend-icon="mdi-volume-high"
                            thumb-label="always"
                            thumb-size="10"
                            :max="100"
                            :min="0"
                            :step="1"
                            hide-details
                          />
                        </div>
                      </v-list-item>

                      <v-list-item>
                        <div class="font-weight-bold">
                          재생 속도
                        </div>
                        <!-- <div class="d-flex justify-space-around align-center py-4">
                        <v-radio-group inline color="primary" :hide-details="true" :ripple="false" v-model="audioOption.speed">
                          <v-radio label="느림" :value="0.7"></v-radio>
                          <v-radio label="보통" :value="1"></v-radio>
                          <v-radio label="빠름" :value="1.5"></v-radio>
                        </v-radio-group>
                      </div> -->
                        <div
                          style="width: 95%"
                          class="py-4"
                        >
                          <v-slider
                            v-model="audioOption.speed"
                            track-color="primary"
                            prepend-icon="mdi-play-speed"
                            thumb-label="always"
                            thumb-size="10"
                            :max="3"
                            :min="0.5"
                            :step="0.1"
                            hide-details
                          >
                            <template #thumb-label="{ modelValue }">
                              x{{ modelValue }}
                            </template>
                          </v-slider>
                        </div>
                      </v-list-item>

                      <v-list-item>
                        <div class="font-weight-bold">
                          목소리
                        </div>
                        <div class="d-flex justify-space-around align-center pt-4">
                          <v-radio-group
                            v-model="audioOption.voice"
                            inline
                            color="primary"
                            :hide-details="true"
                            :ripple="false"
                          >
                            <v-radio
                              label="여자1"
                              :value="'ko-KR-Standard-B'"
                            />
                            <v-radio
                              label="여자2"
                              :value="'ko-KR-Standard-A'"
                            />
                            <v-radio
                              label="남자1"
                              :value="'ko-KR-Standard-C'"
                            />
                            <v-radio
                              label="남자2"
                              :value="'ko-KR-Standard-D'"
                            />
                          </v-radio-group>
                        </div>
                      </v-list-item>

                      <!-- 띄어쓰기 자동보정 기능 비활성화(-) -->
                      <div class="d-flex align-center px-4">
                        <div class="font-weight-bold">
                          띄어쓰기 자동 보정
                        </div>
                        <v-switch
                          v-model="audioOption.correctSpace"
                          class="ffont-weight-bold px-4"
                          inset
                          color="primary"
                          hide-details
                        />
                      </div>

                      <div class="d-flex align-center px-4">
                        <div class="font-weight-bold">
                          다음기사 자동 재생
                          <p
                            class="text-caption"
                            style="color: rgb(142, 142, 142);"
                          >
                            * 북마크 기사는 다음기사 자동 재생 기능이 지원되지 않습니다.
                          </p>
                        </div>
                        <v-switch
                          v-model="audioOption.ttsAutoPlay"
                          class="ffont-weight-bold px-4"
                          inset
                          color="primary"
                          hide-details
                        />
                      </div>
                    </v-list>
                  </v-card>
                </v-menu>

                <!-- 5) 화면 최대화 버튼 (햄버거 내부용) -->
                <div
                  v-else-if="
                    item.key === 'backgroundMaximize'
                      && userMobileStore.uiVisible.header.backgroundMaximizeInHamburger
                      && userJS.checkMobile() != 'ios'
                  "
                >
                  <v-tooltip
                    location="left"
                    transition="null"
                    opacity="0"
                    offset="1"
                    width="95"
                    :disabled="userJS.isHandheldDevice()"
                  >
                    <template #activator="{ props: tooltip }">
                      <button
                        id="alignmentControlBtn-mobile"
                        class="mb-1"
                        v-bind="tooltip"
                        @click="onClickFullScreen"
                      >
                        <i class="kebab mdi mdi-overscan" />
                      </button>
                    </template>

                    <!-- 툴팁 내용 -->
                    <div class="text-caption d-flex align-center">
                      화면 최대화하기
                    </div>
                  </v-tooltip>
                </div>
              </div>
            </v-card>
          </v-menu>
        </div>
      </div>
    </v-app-bar>

    <!-- sidebar 1depth -->
    <v-navigation-drawer
      v-if="userMobileStore.uiVisible.leftSidebar.sidebar"
      id="sidebar1Depth"
      v-model="mainDrawer"
      width="60"
      permanent
      persistent
      disable-resize-watcher
      style="z-index: 500;"
      touchless
    >
      <!-- 매체 선택 버튼 -->
      <div class="py-4 d-flex flex-column justify-center align-center">
        <button
          v-if="userMobileStore.uiVisible.leftSidebar.mediaSelect && userStore.$getRoleCount() == 1"
          type="button"
          class="menutab"
        >
          <span
            class="v-btn__content"
            max-width="100%"
            data-no-activator=""
          >
            <span class="menutab-label-ellipsis">{{ selectedMdName }}</span>
          </span>
        </button>
        <!-- 20250522 -->
        <v-menu
          v-else
          id="mediaSel-menu"
          location="bottom"
          transition="expand-x-transition"
          :disabled="isPageLoading"
        >
          <template #activator="{ props }">
            <v-tooltip
              location="right"
              transition="null"
              opacity="0"
              offset="3"
              :disabled="userJS.isHandheldDevice()"
            >
              <template #activator="{ props: tooltip }">
                <button
                  v-show="userMobileStore.uiVisible.leftSidebar.mediaSelect && userStore.$getRoleCount() != 1"
                  type="button"
                  class="menutab"
                  :style="isPageLoading ? { opacity: '0.7' } : {}"
                  :aria-disabled="isPageLoading ? 'true' : 'false'"
                  v-bind="mergeProps(props, tooltip)"
                >
                  <span
                    class="v-btn__content"
                    max-width="100%"
                    data-no-activator=""
                  >
                    <!-- 매체 변경 동안 로딩 표시 -->
                    <template v-if="isPageLoading && pageLoadingType === 'media'">
                      <v-progress-circular
                        indeterminate
                        size="14"
                        width="2"
                        color="primary"
                      />
                    </template>
                    <template v-else>
                      <span class="menutab-label-ellipsis">{{ selectedMdName }}</span>
                      <span
                        v-if="!isPageLoading"
                        class="mdi mdi-chevron-down"
                      />
                    </template>
                  </span>
                </button>
              </template>
              <div class="text-caption d-flex align-center">
                {{ (isPageLoading && pageLoadingType === 'media') ? pageLoadingMessage : isPageLoading ? pageLoadingMessage : selectedMdName }}
              </div>
            </v-tooltip>
          </template>

          <v-card
            class="mx-auto"
            min-width="inherit"
            max-width="300"
            style="position: relative; left: -10.5px; top: -0.5px;"
          >
            <v-list
              density="compact"
              class="pa-0 drop"
            >
              <v-list-item
                v-for="([key, media]) in Object.entries(userStore.$getRole())"
                :key="key"
                :title="media.mdName"
                :value="key"
                :ripple="false"
                class="mediaSel-menu-list"
                :class="media.mdName == selectedMdName ? 'txt-co' : ''"
                @click="changeRoleSelection(media.mdName);"
              />
            </v-list>
          </v-card>
        </v-menu>
      </div>

      <!-- leftSidebar.$tabs() 순서를 그대로 따라감 -->
      <v-list
        class="d-flex flex-column justify-center h-100"
      >
        <div
          v-for="sideTab in sidebarTabs"
          :key="sideTab.key"
        >
          <v-btn
            v-if="sideTab.key === 'articleList' && userMobileStore.uiVisible.leftSidebar[sideTab.key]"
            :class="{ 'active' : tab == 'option-1'}"
            class="my-2"
            prepend-icon="mdi-format-list-bulleted"
            stacked
            density="compact"
            variant="text"
            :ripple="false"
            @click.stop="DrawerOptionChange('option-1');"
          >
            <p class="navBtnText">
              기사목록
            </p>
          </v-btn>
          <v-btn
            v-if="sideTab.key === 'articleSearch' && userMobileStore.uiVisible.leftSidebar[sideTab.key]"
            :class="{ 'active' : tab == 'option-2'}"
            class="my-2"
            prepend-icon="mdi-magnify"
            stacked
            density="compact"
            variant="text"
            :ripple="false"
            @click.stop="DrawerOptionChange('option-2'); userKeywordGroupStore.$showKeywordList();"
          >
            <p class="navBtnText">
              기사찾기
            </p>
          </v-btn>
          <v-btn
            v-if="sideTab.key === 'bookmarkList' && userMobileStore.uiVisible.leftSidebar[sideTab.key] && userStore.$showFeature('scrap')"
            :class="{ 'active' : tab == 'option-3'}"
            class="my-2"
            prepend-icon="mdi-bookmark-outline"
            stacked
            density="compact"
            variant="text"
            :ripple="false"
            @click.stop="DrawerOptionChange('option-3'); showScrapList()"
          >
            <p class="navBtnText">
              북마크
            </p>
          </v-btn>
          <v-btn
            v-if="sideTab.key === 'sendMail' && userMobileStore.uiVisible.leftSidebar[sideTab.key]"
            :class="{ 'active' : tab == 'option-4'}"
            class="my-2"
            prepend-icon="mdi-email-outline"
            stacked
            density="compact"
            variant="text"
            :ripple="false"
            @click.stop="DrawerOptionChange('option-4'); userEmailStore.$showEmailList(true);"
          >
            <p class="navBtnText">
              메일전송
            </p>
          </v-btn>
          <v-btn
            v-if="sideTab.key === 'info' && userMobileStore.uiVisible.leftSidebar[sideTab.key]"
            :class="{ 'active' : tab == 'option-5'}"
            class="my-2"
            prepend-icon="mdi-information-outline"
            stacked
            density="compact"
            variant="text"
            :ripple="false"
            @click.stop="DrawerOptionChange('option-5'); openNotionInformation();"
          >
            <p class="navBtnText">
              정보
            </p>
          </v-btn>
        </div>
      </v-list>

      <template #append>
        <v-divider length="60" />
        <!-- 계정 표시 버튼 -->
        <div
          v-if="userMobileStore.uiVisible.leftSidebar.profileInitialMark"
          class="px-1 pt-4 pb-2 d-flex justify-center"
          :class="!userMobileStore.uiVisible.leftSidebar.themeToggle ? 'pb-4' : 'pb-2'"
        >
          <v-avatar
            size="small"
            color="primary"
          >
            <span class="text-h6">{{ accountChar }}</span>
          </v-avatar>
        </div>
        <div
          v-if="userMobileStore.uiVisible.leftSidebar.themeToggle"
          class="pa-1 d-flex justify-center"
          :class="{'py-4': !userMobileStore.uiVisible.leftSidebar.profileInitialMark}"
        >
          <v-tooltip
            location="right"
            transition="null"
            opacity="0"
            offset="7"
            :width="currentTheme == 'lightTheme' ? '95' : '106'"
            :disabled="userJS.isHandheldDevice()"
          >
            <template #activator="{ props: tooltip }">
              <v-btn
                icon="mdi-cog"
                elevation="0"
                :ripple="false"
                v-bind="tooltip"
                @click="toggleTheme();"
              >
                <span
                  v-if="currentTheme == 'lightTheme'"
                  class="material-symbols-outlined themeBtn dark-mode"
                >dark_mode</span>
                <span
                  v-else
                  class="material-symbols-outlined themeBtn light-mode"
                >light_mode</span>
              </v-btn>
            </template>

            <!-- 툴팁 내용 -->
            <div
              class="text-caption d-flex align-center"
            >
              {{ currentTheme == 'lightTheme' ? '다크모드로 변경' : '라이트모드로 변경' }}
            </div>
          </v-tooltip>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- sidebar 2depth -->
    <nested-drawer
      v-if="userMobileStore.uiVisible.leftSidebar.sidebar"
      id="nestedDrawer"
      :vw="vw"
      :datepicker="datepicker"
      :media-seq="mediaSeq"

      :page-side="pageSide"
      :nested-drawer="nestedDrawer"
      :tab="tab"

      :open="open"
      :set-article-list-open-group="setArticleListOpenGroup"
      :news="newsImages"
      :thumbnail-bind="_pageSideToArray"
      :selected-article-serial="selectedArticleSerial"
      :selected-article-group-serial="selectedArticleGroupSerial"
      :role-selection="roleSelection"

      :show-scrap-list="showScrapList"
      :scrap-serial-list="scrapSerialList"
      :scrap-alignment="scrapAlignment"
      :selected-scrap-seq="selectedScrapSeq"
      :selected-scrap-group-seq="selectedScrapGroupSeq"

      :selected-page-index="selectedPageIndex"

      :drawer5="drawer5"

      @call-remove-scrap-a-p-i="removeScrapAPI"
      @call-scrap-list-by-scrap-date="sortScrapList"
      @call-scrap-list-by-publication-date="sortScrapList"
      @change-selected-scrap-seq="changeSelectedScrapSeq"
      @handle-list-click="handleListClick"
      @call-move-news-paper="moveNewsPaper"
      @call-show-article-detail-view="showArticleDetailView"
      @call-keyword-from-search-results="callKeywordFromSearchResults"
      @set-selected-scrap-group-seq="setSelectedScrapGroupSeq"
      @nested-drawer-to-false="nestedDrawerToFalse"
    />

    <!-- 보이지 않는 인쇄 영역 -->
    <iframe
      class="printPageDiv"
      width="0"
      height="0"
      name="hiddenframeForPage"
      style="display: none;"
    />

    <!-- 지면 영역 : 양/단면 선택버튼으로 toggle -->
    <v-main
      class="bg-color-custom"
    >
      <!-- 지면 이미지 영역 -->
      <PaperCenter
        id="paperCenter"
        :style="{ height: mobile ? `calc(100% - 60px)` : '100%' }"
        :vh="vh"
        :papers="newsImages"
        :selected-serial="selectedArticleSerial"
        :thumb-idx="selectedPageIndex"
        :page-side="pageSide"
        :search-keyword="keywordFromSearchResults"
        :scrap-data="scrapData"
        :scrap-serial-list="scrapSerialList"
        :media-seq="mediaSeq"
        :is-full-screen="isFullScreen"
        :article-detail-view-data="articleDetailViewData"
        :drawer5="drawer5"
        :tab="tab"
        :is-tts-playing="isTtsPlaying"
        @pre-next="setupFunc.preNext"
        @to-target-page="setupFunc.toTargetPage"
        @detail-view="handleListClick"
        @add-bookmark="addScrapAPI"
        @paper-loaded="onPaperLoaded"
      />
    </v-main>

    <!-- 기사 상세보기 창 -->
    <ArticleDetailView
      id="articleDetailView"
      :vw="vw"
      :style="{ height: mobile ? `calc(100% - 60px)` : '100%' }"
      :drawer5="drawer5"
      :selected-article-serial="selectedArticleSerial"
      :article-detail-view-data="articleDetailViewData"
      :scrap-serial-list="scrapSerialList"
      :media-name="mediaName"
      :media-seq="mediaSeq"
      :toggle-scrap-active="toggleScrapActive"
      :role-selection="roleSelection"
      :nested-drawer="nestedDrawer"
      :main-drawer="mainDrawer"
      :current-theme="currentTheme"
      :search-keyword="keywordFromSearchResults"
      @change-drawer5="changeDrawer5"
      @cancel-article-select="cancelArticleSelect"
      @call-toggle-scrap="toggleScrap"
      @call-download-news-image="downloadNewsImage"
      @print-alert-to-true="printAlertToTrue"
      @share-s-n-s-alert-to-true="shareSNSAlertToTrue"
    />

    <!-- 북마크 생성/삭제, 인쇄, 저장, 공유 기능 활성화 시 알림창 template  -->
    <AllSnackbars
      :vw="vw"
      :role-selection="roleSelection"
    />

    <!-- 기사 상세보기 창 보여주지 않을 때 overlay -->
    <v-overlay
      v-model="isAccessDeniedOverlayOn"
      class="align-center justify-center"
      contained
    >
      <v-btn
        color="success"
        @click="isAccessDeniedOverlayOn = false"
      >
        해당 지면을 볼 수 있는 권한이 없습니다.
      </v-btn>
    </v-overlay>

    <!--  자른 지면 북마크 저장 시 모달창 -->
    <v-overlay
      v-model="userJS.isCuttingPageSavingOverlayOn.value"
      class="d-flex align-center justify-center"
      persistent
      no-click-animation
    >
      <v-card
        width="450"
        min-width="0"
        :max-width="vw*85"
      >
        <v-card-title class="download-image-select-title">
          자른 이미지 북마크로 저장
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="d-flex align-center justify-space-between">
            <div>북마크 이름</div>
            <v-combobox
              v-model="userJS.cutting_canvas_title.value"
              :items="userJS.cutting_canvas_proposed_titles.value"
              :no-filter="true"
              :menu-props="{ maxHeight: 200, width: 210,}"
              placeholder="북마크 제목을 입력해주세요."
              variant="outlined"
              class="cuttingCanvas-title-input-border no-input-border ms-2"
              style="font-size: 15px !important; width: 70%;"
              hide-details
              :single-line="true"
              density="compact"
              maxlength="200"
            />
          </div>
        </v-card-text>

        <v-card-actions class="pb-4 px-4">
          <v-btn
            color="surface-variant"
            variant="flat"
            @click="cuttingCanvas_unsaveScrap()"
          >
            취소
          </v-btn>

          <v-spacer />

          <v-btn
            color="primary"
            variant="flat"
            @click="cuttingCanvas_saveScrap();"
          >
            저장
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>

    <v-overlay
      v-model="userKeywordGroupStore.isKeywordGroupOverlayOn"
      transition="false"
      class="d-flex align-center justify-center"
      eager
    >
      <KeywordGroupModal
        :vw="vw"
      />
    </v-overlay>

    <v-overlay
      v-model="userEmailStore.isEmailOverlayOn"
      transition="false"
      class="d-flex align-center justify-center"
      eager
      :close-on-content-click="userEmailStore.isShowBookmark ? true : false"
    >
      <EmailModal
        :vw="vw"
      />
    </v-overlay>
  </v-app>
</template>

<script setup>
  import PaperCenter from '@/components/user/PaperCenter.vue';
  import NestedDrawer from '@/components/user/NestedDrawer.vue';
  import ArticleDetailView from '@/components/user/ArticleDetailView.vue';
  import AllSnackbars from '@/components/user/AllSnackbars.vue';
  import KeywordGroupModal from '@/components/user/modal/KeywordGroupModal.vue';
  import EmailModal from '@/components/user/modal/EmailModal.vue';

  import axios from "axios"
  import { ref, reactive, computed, mergeProps, onMounted, onBeforeUnmount, onUnmounted, onUpdated, watch, nextTick } from 'vue';
  import { useTheme, useDisplay } from 'vuetify'
  import { useUserStore, useUserInfoStore, useUserMobileStore, useUserAlertStore , useUserKeywordGroupStore, useUserEmailStore } from '@/store';
  const userStore = useUserStore();
  const userInfoStore = useUserInfoStore();
  const userMobileStore = useUserMobileStore();
  const userAlertStore = useUserAlertStore();
  const userKeywordGroupStore = useUserKeywordGroupStore();
  const userEmailStore = useUserEmailStore();

  import { useRouter } from 'vue-router';
  const router = useRouter();

  import { suppressApiAlert } from '@/main.js';

  import { userJS } from '@/assets/js/index';
  import { fabric } from 'fabric'

  import '../../assets/css/user/reset.css'
  import '../../assets/css/user/customCss.css'

  let currentLink = null;
  let isMobileCache = null;

  const loadStyle = () => {
    if (isMobileCache === mobile.value) return;
    isMobileCache = mobile.value;

    const href = mobile.value ? '/css/user/mobile_style.css' : '/css/user/origin_style.css';

    const next = document.createElement('link');
    next.rel = 'stylesheet';
    next.href = href;

    next.onload = () => {
      if (currentLink && currentLink.parentNode) currentLink.parentNode.removeChild(currentLink);
      currentLink = next;
    };

    next.onerror = () => {
      // 실패 시 기존 유지
      if (next.parentNode) next.parentNode.removeChild(next);
    };

    document.head.appendChild(next);
  };

  // ======================================= [START] ==================================
  const { mobile, smAndDown, md, smAndUp, mdAndUp, lg, xlAndUp, name, width, height } = useDisplay(); // 반응형을 위한 변수 (vuetify)
  // 반응형 구현 방법 : plugins/vuetify.js의 display/thresholds에서 break points 지정.
  // 원하는 태그에 :class="displaySize" 추가하여 해당 class마다 원하는 css 구현 가능.
  const displaySize = computed(()=> {
    switch (name.value) {
      case 'xs': return 'xs';
      case 'sm': return 'sm';
      case 'md': return 'md';
      case 'lg': return 'lg';
      case 'xl': return 'xl';
      case 'xxl': return 'xxl';
      default: return undefined;
    }
  });
  // 반응형 높이
  // 1. 여기서 break points마다 height 지정.
  // 2. 원하는 태그에 :height="myHeight" 추가하기.
  const myHeight = computed(() => {
    switch (name.value) {
      case 'xs': return 100;
      case 'sm': return 200;
      case 'md': return 300;
      case 'lg': return 400;
      default : return 500;
    }
  });

  // 기사 상세보기 창 내 정보
  const articleDetailViewData = ref({});
  // ======================================= [END] ==================================

  const keywordFromSearchResults = ref([]);// 기사 찾기 - 기사 검색 시 PaperCenter.vue에서 검색 키워드 하이라이트 시 사용할 변수
  function callKeywordFromSearchResults(keyword){//emit from NestedDrawer.vue
    keywordFromSearchResults.value = keyword;
  }

  // 로고 버튼 클릭 시 새로운 창으로 해당 매체 사이트 열기
  function openNewSite() {
    let location = '';

    // 추후 PC용 화면 레이아웃 설정이 따로 생긴다면 이 코드로 대체하기 (-)
    // const isMobile = mobile.value;
    // // 1) PC 이거나, 모바일이지만 customUI가 비어 있을 때
    // //    → 항상 PC용 URL 사용
    // if (!isMobile || userMobileStore.isEmptyMobileUI) {
    //   location = userInfoStore.LOGO_SITE_URL;
    // } else {
    //   // 2) 모바일 + customUI 존재할 때
    //   //    → 모바일용 customUI.logoButton.subKey 사용
    //   const mobileUrlObj = userMobileStore.$getMobileLayout(true, 'header', 'logoButton');

    //   if (mobileUrlObj && mobileUrlObj.subKey) {
    //     // showYn이 'Y'인 건 이미 v-if에서 한 번 걸러졌지만, 한 번 더 체크.
    //     if (mobileUrlObj.showYn === 'Y') {
    //       location = mobileUrlObj.subKey;
    //     }
    //   }

    //   // 혹시 mobileUrlObj이 null이거나 subKey가 비어있으면 PC URL로 fallback
    //   if (!location) {
    //     location = userInfoStore.LOGO_SITE_URL;
    //   }
    // }

    // pc와 모바일 모두에서 customUI.header.logoButton를 우선 적용하도록 변경된 로직 - 20251212 최지현
    // 1) PC 이거나, 모바일이지만 customUI가 비어 있을 때(사용자가 아예 url 설정 안함.)
    if (userMobileStore.isEmptyMobileUI) {
      return;
    } else {
      // 2) 모바일 + customUI 존재할 때
      const mobileUrlObj = userMobileStore.$getMobileLayout(true, 'header', 'logoButton');

      if (mobileUrlObj && mobileUrlObj.subKey && mobileUrlObj.showYn === 'Y') { // showYn이 'Y'인 건 이미 v-if에서 한 번 걸러졌지만, 한 번 더 체크.
        location = mobileUrlObj.subKey;
      }
    }

    if (location) {
      window.open(location, '_blank');
    }
  }

  // 지면 발행일(String) 배열 ex) ["20240101", "20240102", ..]
  const pubDaysStrArr = ref([]);
  // 캘린더 - 선택된 날짜
  const datepicker = ref(new Date());
  const calendarBrowseDate = ref(new Date(datepicker.value || new Date())); // 캘린더에서 지금 보고있는 지금 보고 있는 년/월
  const openCalendarYn = ref(false);
  watch(openCalendarYn, (newVal, oldVal)=>{// 캘린더 열 때 오류에 의한 날짜 범위 처리 -> 알림창으로만(+)
    if( !oldVal && newVal && pubDaysStrArr.value.length == 0) {
      alert('검색 날짜 범위가 잘못됐습니다.');
    }
    if (!oldVal && newVal) {
      calendarBrowseDate.value = new Date(datepicker.value || new Date()); // 이렇게 하면 캘린더를 새로 열 때마다 실제 선택 날짜 기준으로 캘린더가 맞춰짐
    }
  })
  // 캘린더 또는 매체 변경 중이면 캘린더 열기를 막기 위함.
  const isCalendarMenuBlocked = computed(() => {
    return isPageLoading.value || pageLoadingType.value === 'media';
  });

  // 모바일 ui 옵션 중에 하나인 날짜 셀렉트 박스 기능 구현하기 위해 필요한 변수들
  const selectedYear = ref(null);
  const selectedMonth = ref(null);
  const selectedDay = ref(null);

  function syncDateSelectBoxesFromDate(date) {
    if (!date || Number.isNaN(new Date(date).getTime())) return;

    const d = new Date(date);
    selectedYear.value = d.getFullYear();
    selectedMonth.value = d.getMonth() + 1;
    selectedDay.value = d.getDate();
  }

  async function initMobileDateSelectBoxes() {
    // localpageSerial이 있으면 날짜 초기화 건너뜀
    if (userStore.localpageSerial !== '') return;

    const today = new Date();

    // 1. 우선 datepicker를 오늘로 맞춤
    datepicker.value = today;
    calendarBrowseDate.value = new Date(today);

    // 2. 오늘 기준 연도의 발행일 목록을 먼저 불러옴
    const ok = await fetchPublicationDatesForYear(today);

    // 3. 오늘이 발행일이면 오늘 그대로 사용
    const todayYmd =
      `${today.getFullYear()}${pad2(today.getMonth() + 1)}${pad2(today.getDate())}`;

    let targetYmd = null;

    if (ok && pubDaysStrArr.value.includes(todayYmd)) {
      targetYmd = todayYmd;
    } else if (ok) {
      // 오늘이 발행일이 아니면 오늘 이전/이하 기준 가장 가까운 발행일 또는 마지막 발행일
      const sorted = [...pubDaysStrArr.value].sort();
      const todayNum = Number(todayYmd);

      const notFuture = sorted.filter(ymd => Number(ymd) <= todayNum);
      targetYmd = notFuture.length ? notFuture[notFuture.length - 1] : sorted[sorted.length - 1];
    }

    if (!targetYmd) return;

    const nextDate = makeDateFromYmd(targetYmd);
    datepicker.value = nextDate;
    calendarBrowseDate.value = new Date(nextDate);
    syncDateSelectBoxesFromDate(nextDate);
  }

  // 변경 시도한 날짜가 발행일이 아닐 때 이전 날짜로 돌아가기 위한 변수들 (dateSelectBoxMode == KEEP_PREVIOUS일 때만 사용)
  const lastValidYear = ref(null);
  const lastValidMonth = ref(null);
  const lastValidDay = ref(null);

  const dateSelectBoxMode = computed(() => {
    return userMobileStore.$getMobileLayout(mobile.value, 'header', 'dateSelectBox', 'mode') || 'KEEP_PREVIOUS';
  });
  function pad2(v) {
    return String(v).padStart(2, '0');
  }
  function formatYmdToIso(ymd) {
    return `${ymd.slice(0, 4)}-${ymd.slice(4, 6)}-${ymd.slice(6, 8)}`;
  }
  function makeDateFromYmd(ymd) {
    return new Date(`${ymd.slice(0, 4)}-${ymd.slice(4, 6)}-${ymd.slice(6, 8)}`);
  }
  function getKorWeekdayText(ymd) { // '일' 셀렉트 박스에서 요일 정보를 띄우기 위함.
    const d = makeDateFromYmd(ymd);
    if (Number.isNaN(d.getTime())) return '';

    const weekday = d.toLocaleDateString('ko-KR', { weekday: 'short' });
    return weekday; // 예: "목"
  }

  /** 모드별 날짜 결정용 공통 함수 추가 -------------------------------------------
   * dateSelectBoxMode == KEEP_PREVIOUS
    → 기존 월/일 또는 일을 최대한 유지
    → 그 날짜가 발행일 목록에 있으면 이동
    → 없으면 return;
   * dateSelectBoxMode == CHANGE_LAST_DATE
    → 바뀐 연도/월 기준 마지막 발행일로 이동
   */
  function getLastPublishedYmdInYear(year) {
    const filtered = pubDaysStrArr.value
      .filter(ymd => Number(ymd.slice(0, 4)) === Number(year))
      .sort();

    return filtered.length ? filtered[filtered.length - 1] : null;
  }
  function getLastPublishedYmdInMonth(year, month) {
    const filtered = pubDaysStrArr.value
      .filter(ymd =>
        Number(ymd.slice(0, 4)) === Number(year) &&
        Number(ymd.slice(4, 6)) === Number(month)
      )
      .sort();

    return filtered.length ? filtered[filtered.length - 1] : null;
  }
  function getKeepPreviousYmdInYear(year) {
    const mm = pad2(selectedMonth.value);
    const dd = pad2(selectedDay.value);
    const ymd = `${year}${mm}${dd}`;

    return pubDaysStrArr.value.includes(ymd) ? ymd : null;
  }
  function getKeepPreviousYmdInMonth(year, month) {
    const dd = pad2(selectedDay.value);
    const ymd = `${year}${pad2(month)}${dd}`;

    return pubDaysStrArr.value.includes(ymd) ? ymd : null;
  }
  function applyResolvedYmdOrAlert(targetYmd) {
    if (!targetYmd) {
      // 발행 날짜가 아닌 경우
      return;
    }

    const nextDate = makeDateFromYmd(targetYmd);
    if (Number.isNaN(nextDate.getTime())) {
      // 발행 날짜가 아닌 경우
      return;
    }

    datepicker.value = nextDate;
  }
  // -------------------------------------------------------------------------

  // 날짜 클릭 시 처리할 함수
  function handleDateClick(modelValue) {
    if (!modelValue) return;

    const nextDate = new Date(modelValue);
    if (Number.isNaN(nextDate.getTime())) return;

    datepicker.value = nextDate;
    calendarBrowseDate.value = new Date(nextDate);
    openCalendarYn.value = false;

    // 여기서는 실제 로딩 상태를 켜지 않음.
    // 실제 갱신 시작 지점(getPublicationDate)에서 로딩을 켠다.
  }

  // --------------------------------------------------------------------------------------------------------------------------------------------------

  // 날짜 셀렉트 박스 관련 기능 ---------------------------------------------------------------------------------------------------------------------------
  // 년 옵션 - 현재 연도부터 1900년까지 생성, 필요하면 startYear 조정하기
  const yearSelectOptions = computed(() => {
    // 매체별 - 해당 매체의 발행 시작 연도 또는 1900년 중 더 늦은 연도
    const publicationYearsArr = _normalizePublicationYears(roleSelection.value);
    const startYear = publicationYearsArr.length ? Math.min(...publicationYearsArr) : 1900;
    const endYear = new Date().getFullYear();

    const years = [];
    for (let y = endYear; y >= startYear; y--) {
      years.push({
        title: `${y}`,
        value: y,
      });
    }

    return years;
  });
  // 월 옵션
  const monthSelectOptions = computed(() => {
    if (!selectedYear.value) return [];

    const months = [...new Set(
      pubDaysStrArr.value
        .filter(ymd => Number(ymd.slice(0, 4)) === Number(selectedYear.value))
        .map(ymd => Number(ymd.slice(4, 6)))
    )].sort((a, b) => a - b);

    return months.map(month => ({
      title: `${month}`,
      value: month,
    }));
  });
  // 일 옵션
  const daySelectOptions = computed(() => {
    if (!selectedYear.value || !selectedMonth.value) return [];

    const ymds = [...new Set(
      pubDaysStrArr.value
        .filter(ymd =>
          Number(ymd.slice(0, 4)) === Number(selectedYear.value) &&
          Number(ymd.slice(4, 6)) === Number(selectedMonth.value)
        )
    )].sort();

    return ymds.map(ymd => {
      const day = Number(ymd.slice(6, 8));
      const weekday = getKorWeekdayText(ymd);

      return {
        title: `${day} (${weekday})`,
        value: day,
      };
    });
  });
  const pageSelectOptions = computed(() => {
    const count = Array.isArray(newsImages.value) ? newsImages.value.length : 0;

    return Array.from({ length: count }, (_, i) => ({
      title: `${i + 1}`,
      value: i, // 내부는 index 기준(0부터)
    }));
  });
  // 실제 날짜 적용 함수
  function applyDateFromSelectBoxes(year, month, day) {
    if (!year || !month || !day) return;

    const ymd = `${year}${pad2(month)}${pad2(day)}`;
    const exists = pubDaysStrArr.value.includes(ymd);
    if (!exists) return;

    const nextDate = new Date(formatYmdToIso(ymd));
    if (Number.isNaN(nextDate.getTime())) return;

    if (datepicker.value?.format('yyyy-MM-dd') === formatYmdToIso(ymd)) {
      return;
    }

    datepicker.value = nextDate;
  }
  const isDateSelectLoading = ref(false); // 날짜 셀렉트 박스 로딩 상태
  // 메뉴 열릴 때 현재 선택값으로 자동 스크롤
  function scrollToSelected(menuClass) {
    nextTick(() => {
      const activeItem = document.querySelector(`${menuClass} .v-list-item--active`);
      if (activeItem) {
        activeItem.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    });
  }
  // PaperCenter에서 이미지 렌더 완료 시 호출 → 날짜 셀렉트 박스 로딩 해제
  function onPaperLoaded() {
    isDateSelectLoading.value = false;
    isPageLoading.value = false;
    pageLoadingMessage.value = '';
    pageLoadingType.value = '';
  }
  // 년도 변경
  async function handleYearSelectChange(year) {
    const prevYear = lastValidYear.value;
    const prevMonth = lastValidMonth.value;
    const prevDay = lastValidDay.value;

    selectedYear.value = year;
    isDateSelectLoading.value = true;

    try {
      const probeDate = new Date(`${year}-01-01`);
      const ok = await fetchPublicationDatesForYear(probeDate);

      if (!ok) {
        selectedYear.value = prevYear;
        selectedMonth.value = prevMonth;
        selectedDay.value = prevDay;
        isDateSelectLoading.value = false; // 에러 경로: 즉시 해제

        const publicationYearsText = _normalizePublicationYears(roleSelection.value)?.length
          ? _normalizePublicationYears(roleSelection.value).join(', ')
          : '발행 가능 연도 정보 없음';

        alert(`${year}년도에는 발행 날짜 정보가 없습니다.\n발행 년도 : ${publicationYearsText}`);
        return;
      }

      let targetYmd = null;

      if (dateSelectBoxMode.value === 'CHANGE_LAST_DATE') {
        targetYmd = getLastPublishedYmdInYear(year);
      } else {
        const keepYmd = getKeepPreviousYmdInYear(year);
        if (keepYmd) {
          targetYmd = keepYmd;
        } else {
          targetYmd = getLastPublishedYmdInYear(year);
          if (targetYmd) {
            const y = targetYmd.slice(0, 4);
            const m = Number(targetYmd.slice(4, 6));
            const d = Number(targetYmd.slice(6, 8));
            alert(`${year}년 ${selectedMonth.value}월 ${selectedDay.value}일은 발행일이 아닙니다.\n${y}년 ${m}월 ${d}일(마지막 발행일)로 이동합니다.`);
          }
        }
      }

      applyResolvedYmdOrAlert(targetYmd);
      // 성공 경로: isDateSelectLoading은 PaperCenter.vue의 @paper-loaded emit에서 해제
    } catch (e) {
      // 예상치 못한 예외 발생 시 안전하게 해제
      isDateSelectLoading.value = false;
      console.error('handleYearSelectChange 오류:', e);
    }
  }
  // 월 변경
  async function handleMonthSelectChange(month) {
    const prevYear = lastValidYear.value;
    const prevMonth = lastValidMonth.value;
    const prevDay = lastValidDay.value;

    selectedMonth.value = month;
    isDateSelectLoading.value = true;

    try {
      const probeDate = new Date(`${selectedYear.value}-${pad2(month)}-01`);
      const ok = await fetchPublicationDatesForYear(probeDate);

      if (!ok) {
        selectedYear.value = prevYear;
        selectedMonth.value = prevMonth;
        selectedDay.value = prevDay;
        isDateSelectLoading.value = false; // 에러 경로: 즉시 해제
        alert(`${selectedYear.value}년 ${month}월에는 발행 날짜 정보가 없습니다.`);
        return;
      }

      const monthHasDates = pubDaysStrArr.value.some(ymd =>
        Number(ymd.slice(0, 4)) === Number(selectedYear.value) &&
        Number(ymd.slice(4, 6)) === Number(month)
      );

      if (!monthHasDates) {
        selectedYear.value = prevYear;
        selectedMonth.value = prevMonth;
        selectedDay.value = prevDay;
        isDateSelectLoading.value = false; // 에러 경로: 즉시 해제
        alert(`${selectedYear.value}년 ${month}월에는 발행 날짜 정보가 없습니다.`);
        return;
      }

      let targetYmd = null;

      if (dateSelectBoxMode.value === 'CHANGE_LAST_DATE') {
        targetYmd = getLastPublishedYmdInMonth(selectedYear.value, month);
      } else {
        const keepYmd = getKeepPreviousYmdInMonth(selectedYear.value, month);
        if (keepYmd) {
          targetYmd = keepYmd;
        } else {
          targetYmd = getLastPublishedYmdInMonth(selectedYear.value, month);
          if (targetYmd) {
            const m = Number(targetYmd.slice(4, 6));
            const d = Number(targetYmd.slice(6, 8));
            alert(`${selectedYear.value}년 ${month}월 ${selectedDay.value}일은 발행일이 아닙니다.\n${m}월 ${d}일(마지막 발행일)로 이동합니다.`);
          }
        }
      }

      if (!targetYmd) {
        selectedYear.value = prevYear;
        selectedMonth.value = prevMonth;
        selectedDay.value = prevDay;
        isDateSelectLoading.value = false; // 에러 경로: 즉시 해제
        alert('선택하신 기간 내 매체의 발행 날짜 정보가 없습니다.');
        return;
      }

      applyResolvedYmdOrAlert(targetYmd);
      // 성공 경로: isDateSelectLoading은 @paper-loaded emit에서 해제
    } catch (e) {
      isDateSelectLoading.value = false;
      console.error('handleMonthSelectChange 오류:', e);
    }
  }
  // 일 변경
  async function handleDaySelectChange(day) {
    isDateSelectLoading.value = true;
    selectedDay.value = day;
    applyDateFromSelectBoxes(selectedYear.value, selectedMonth.value, selectedDay.value);
    // applyDateFromSelectBoxes는 동기이므로 watch(datepicker)가 getPublicationDate를 비동기로 호출하게 되고,
    // getPublicationDate 내에서 setNews()가 비동기로 실행됨.
    // setNews() 완료 후 isDateSelectLoading = false 처리를 setNews() 내에 추가
  }

  // 캘린더 관련 기능 ----------------------------------------------------------------------------------------------------------------------------------

  // 캘린더 통해 날짜 변경했을 때 1) 지난 기사 선택 상태 모두 해제 2) 우측 기사 상세보기 창만 닫기 3) 해당 날짜 지면으로 변경 함수
  async function setNews() {

    // 캘린더 닫기
    openCalendarYn.value = false;
    // tts 종료하도록.
    userJS.stopTts();
    // 기사 상세보기 창 닫기
    drawer5.value = false;
    // 초기화
    selectedArticleSerial.value = '';// 선택한 기사 serial
    selectedArticleGroupSerial.value = '';// 선택한 지면 serial
    selectedPageIndex.value = 0;// 선택한 지면 index
    art.value = null;//선택한 tts 대상 기사
    presentTtsSerial = ''//최근 실행한 tts 기사 serial
    keywordFromSearchResults.value = [];//검색 키워드

    // 새로운 기사 목록 정보 및 지면 이미지 띄우기
    await showArticleList(ROOT_SERIAL.value);

    // 20250918 최지현 - datepicker.value를 별지 날짜로 변경시켜 watch에 의해 해당 별지 날짜 지면을 띄운 후,
    // 해당 별지 페이지로 이동하도록!
    if(userStore.localpageSerial == '') return;
    const realLocalpageIdx = userStore.$setLocalpageSerial(allSerial.value);
    if(realLocalpageIdx !== "false"){
      const result = `group-${realLocalpageIdx}`;
      document.getElementById(result).click();
    } else {
      userStore.localpageSerial == '';
      if(userStore.localpageSerial == '') {
        datepicker.value = new Date();// 현재날짜로 다시 실행.
      }
    }
  }

  const isPageLoading = ref(false); // 지면 이미지 갱신 중 여부 (PC/모바일 공통)
  const pageLoadingMessage = ref(''); // 로딩 중 header 캘린더 버튼, 매체 변경 버튼 툴팁 메시지
  const pageLoadingType = ref(''); // 'date' | 'media' | ''

  let isSyncingRoleDatepicker = false; // datepicker watcher 중복호출 차단용

  // 캘린더 - 선택된 년도
  let isYearChanged = false;
  async function onYearChange(year) {
    const publicationYearsArr = _normalizePublicationYears(roleSelection.value);
    const minYear = publicationYearsArr.length ? Math.min(...publicationYearsArr) : 1900;
    if (Number(year) < minYear) return;

    const base = new Date(calendarBrowseDate.value || datepicker.value || new Date());
    if (Number.isNaN(base.getTime())) return;

    base.setFullYear(Number(year));
    calendarBrowseDate.value = new Date(base);

    try {
      suppressApiAlert.value = true;
      await fetchPublicationDatesForYear(base);
    } finally {
      suppressApiAlert.value = false;
    }
  }

  // 매체마다 발행일 반환 API
  async function publicationDateAPI(date){
    let params = new URLSearchParams();
    params.append('date', date.format('yyyy'));
    params.append('mediaSeq', mediaSeq.value);
    return await userJS._api.getDates(params);
  };
  // 날짜와 시간까지 포함된 배열 -> 시간 제한 시 사용하기 위함.
  const pudDaysAndTimeArr = ref([]);

  // 오픈시간 관련 기능  =======================================================================================

  // 오픈 시간 여부
  const isPossibleTime = ref(false);
  // 매체 변경 시 해당 매체의 오픈시간이 넘지 않아 변경된 매체의 가장 최근 날짜로 이동하기 위함.
  const latestDate = ref('');
  // 오픈시간이 넘는지 확인하는 함수
  function isBefore(targetDateStr, compareDateStr) {// 'yyyyMMdd' 형식의 날짜 간 비교
    const targetDate = new Date(
      parseInt(targetDateStr.substring(0, 4)), // 년
      parseInt(targetDateStr.substring(4, 6)) - 1, // 월 (0-based)
      parseInt(targetDateStr.substring(6, 8)) // 일
    );
    const compareDate = new Date(
      parseInt(compareDateStr.substring(0, 4)),
      parseInt(compareDateStr.substring(4, 6)) - 1,
      parseInt(compareDateStr.substring(6, 8))
    );
    return targetDate <= compareDate;
  }
  // 해당 연도의 발행일 목록 유무만 확인하는 함수 (오픈시간 체크, setNews() 호출 없음)
  // 발행일이 있으면 pubDaysStrArr, pudDaysAndTimeArr를 갱신하고 true 반환
  // 발행일이 없으면(res가 falsy) false 반환
  async function fetchPublicationDatesForYear(date) {
    try {
      // alert 억제 시작 - main.js의 response interceptor에서
      // 해당 년도에 발행일이 없는 경우 반복해서 fetchPublicationDatesForYear()가 실행됨에 따라 관련 alert 반복 실행을 방지하기 위함.
      suppressApiAlert.value = true;
      const res = await publicationDateAPI(date);
      if (res && res.length > 0) {
        pudDaysAndTimeArr.value = res.slice();
        pubDaysStrArr.value = res.map(e => e.date);
        return true;
      }
      return false;
    } catch (error) {
      console.error('발행일 목록 조회 오류:', error);
      return false;
    } finally {
      suppressApiAlert.value = false; // alert 억제 해제 (성공/실패 무관)
    }
  }
  // 매체별(mediaSeq) 열람 가능한 날짜 반환해주는 함수. calendar에서 사용됨.
  async function getPublicationDate(date){// 사용자 사용 기간 : admin 계정 - 신문사 선택 - 메뉴관리 설정에서 변경 가능.
    if (!date) return;

    // 매체 변경 로딩 중이면 날짜 로딩으로 덮어쓰지 않음
    if (pageLoadingType.value !== 'media') {
      isPageLoading.value = true;
      pageLoadingType.value = 'date';
      pageLoadingMessage.value = '날짜가 변경되어 지면 이미지 갱신 중입니다.';
    }

    // 20250926 최지현  - 실제 날짜, 매체, 새로고침이 아니라 캘린더에서 년도만 변경했을 때에는
    // 캘린더에 있는 해당 년도 내 발행일들만 불러오기 위함.
    // -> isYearChanged 사용.

    try {
      const res = await publicationDateAPI(date);
      if(res){
        pudDaysAndTimeArr.value = res.slice();
        pubDaysStrArr.value = [];

        // 오픈 시간 관련 로직 ==================================================================================
        res.forEach((e, index) => {
          // 캘린더에 날짜를 띄우기 위함.
          pubDaysStrArr.value.push(e.date);

          if(isYearChanged) return; // 20250926 최지현

          // 오픈 시간 체크하기 위함.
          if (index === res.length - 1) {// 현재 매체가 발행된 가장 최근 날짜
            latestDate.value = new Date(`${e.date.substring(0, 4)}-${e.date.substring(4, 6)}-${e.date.substring(6, 8)}`);
            if(userStore.$getRole()[roleSelection.value].mdName == '초판') {
              if(isBefore(datepicker.value.format('yyyyMMdd'), `${e.date}`)) {// 초판이 발행된 제일 최근 날짜 확인
                isPossibleTime.value = true;
              } else {
                isPossibleTime.value = false;
              }
            } else {
              if(isBefore(datepicker.value.format('yyyyMMdd'), `${e.date}`)) {// 변경된 매체가 발행된 제일 최근 날짜 확인
                isPossibleTime.value = true;
              } else {
                isPossibleTime.value = false;
              }
            }
          }
        })

        // 20250926 최지현
        if(isYearChanged) {
          isYearChanged = false;
          return true;
        }

        // !!! 오픈시간이 넘지 않았을 때 !!!
        if(!isPossibleTime.value) {
          alert(`아직 ${date.format('yyyy-MM-dd')}에는 ` + selectedMdName.value + ' 열람 시간이 아닙니다.\n' + selectedMdName.value + ' 열람이 가능한 최신 날짜로 이동합니다.');

          // 20250924 최지현 - 별지 페이지 이동 링크로 이동했을 때, 최근 발행 날짜로 넘어갈때에는 별지 이동 serial 파라미터 값을 초기화해줌.
          if(userStore.localpageSerial != ''){
            userStore.localpageSerial = '';
          }

          datepicker.value = latestDate.value;// latestDate : 선택된 매체의 최근 발행 날짜
        }
        // ====================================================================================================

        isPageLoading.value = true;
        // 매체 변경 중이면 pageLoadingType을 'date'로 덮어쓰지 않음
        if (pageLoadingType.value !== 'media') {
          pageLoadingType.value = 'date';
          pageLoadingMessage.value = '날짜가 변경되어 지면 이미지 갱신 중입니다...';
        }

        await setNews();
        return true;

      } else {
        // 실제로 해당 데이터가 없는 경우 main.js의 response interceptor에 의해 alert 창 띄우고 res는 false임.

        // 20250924 최지현 - 만약 별지 페이지 이동 링크의 serial 파라미터에서 해당 날짜값이 이상하다면 알림창 띄우고,
        if(userStore.localpageSerial !== ''){
          alert("특정 지면 바로가기 링크의 지면 날짜가 정확하지 않습니다. \n현재 날짜 지면을 불러옵니다. \n확인 후 다시 시도해 주시기 바랍니다. ");
          userStore.localpageSerial = '';// 만약 별지 페이지 이동 링크 serial 파라미터 초기화!
          datepicker.value = new Date();// 현재 날짜로 다시 실행.
          return true;
        }

        // 이 경우 지면 정보 setting 작업 하지 않음. // await setNews();
        return false;
      }
    } catch (error) {
      console.error('사용자 사용 기간 관련 오류 : ', error);
      return false;
    }
  }

  // v-date-picker 태그의 ':allowed-dates' 속성은 1) Date 속성 날짜가 담긴 배열이나 2) true, false 값을 반환하는 함수를 사용해야 함.
  // pubDaysStrArr 날짜와 일치하는 날짜만 사용자가 캘린더에서 선택가능하도록 하는 함수.
  const allowedDates = (date) => {
    return pubDaysStrArr.value.some(allowedDate => {          // some() -> true or false 반환
      return allowedDate === date.format('yyyyMMdd');
    });
  };

  // ---------------------------------------------------------------------------------------------------------------------------------------------------

  // 캘린더 : 현재 날짜 ~ 허용된 지면보기 기간.------------------------------------------------------------------------------------------------------------
  function maxDate(){
    return pubDaysStrArr.value[pubDaysStrArr.value.length-1];
  }
  function minDate(){
    const publicationYearsArr = _normalizePublicationYears(roleSelection.value);
    if (!publicationYearsArr.length) return undefined;
    return `${Math.min(...publicationYearsArr)}0101`;
  }
  // ---------------------------------------------------------------------------------------------------------------------------------------------------


  // 키워드 검색 시 검색 하이라이트 색상 변경 기능----------------------------------------------------------------------------------------------------------
  const colorPickerInput = ref(null);
  const isColorPickerActive = computed(()=>{
    let isHiShapeExist = userJS.searchHiShapesLayer.value ? true : false;
    let isHiShapeForDetailExist = userJS.searchHiShapesLayer.value ? true : false;
    return isHiShapeExist || isHiShapeForDetailExist;
  })

  function updateColorAtCenterAndDetail(event){
    userStore.searchHiColor = event.target.value;
    userJS.updateSearchHiColor(event); // 이 함수 안에서 pinia에 있는 searchHiColor를 event.target.value로 변경
    if(drawer5.value) userJS.updateSearchHiColorD();
  }
  // ---------------------------------------------------------------------------------------------------------------------------------------------------


  // 전체 지면 인쇄하기 ---------------------------------------------------------------------------------------------------------------------------------
  const imagePrintSelection = ref('low');
  function printPage() {                                                     // 프린트 영역 커스텀 장소 : @media print {}
    userAlertStore.$resetAllAlert();

    let imgQuality = '';
    imgQuality = imagePrintSelection.value;

    let serial = '';
    if (pageSide.value == 1)// 단면
      serial = _pageSideToArray.value[selectedPageIndex.value][0].Serial;
    else// 양면
      serial = presentPageSerial.value;

    /* 화질 선택 */
    if(imgQuality == 'low') {
      serial = serial+'p30';
    } else if(imgQuality == 'medium') {
      serial = serial+'p70';
    }


    let windowObj = window.open(
      '',
      'hiddenframeForPage',
      'width=0, height=0, toolbars=no, scrollbars=yes, status=no, resizable=no'
    );

    let printPageDiv = document.querySelector('.printPageDiv');
    // 안전하게: printPageDiv 내부의 .img만 제거 (부모가 다르면 removeChild 금지)
    if (printPageDiv) {
      const prevImgs = printPageDiv.querySelectorAll('.img'); // 컨테이너 내부에서만 탐색
      prevImgs.forEach(el => {
        if (el.parentNode === printPageDiv) {
          printPageDiv.removeChild(el);
        } else {
          // 혹시라도 다른 부모라면 해당 요소 기준으로 제거
          el.remove?.();
        }
      });
    }
    const img = document.createElement('img');

    let params = new URLSearchParams();
    params.append('filepath', serial);
    params.append('mediaSeq', mediaSeq.value);
    let imageAPIUrl = `${userJS.baseUrl}/paperDown?${params.toString()}`;

    // axios로 blob 다운로드 → ObjectURL을 <img>에 설정
    // '/paperDown' api 호출 시 axios request interceptor에서 header에 Pmaster-Sid를 추가하기 위함.
    const setBlobAndPrint = async () => {
      try {
        const { data: blob } = await axios.get(imageAPIUrl, {
          responseType: 'blob',
          withCredentials: true, // 인터셉터 헤더 + 쿠키 필요 시
        });
        const objectUrl = URL.createObjectURL(blob); // Blob → ObjectURL

        img.src = objectUrl;
        img.classList.add('img');
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.style.maxWidth = '100%';
        img.style.maxHeight = '100%';
        img.style.display = 'block';
        img.style.margin = '0 auto';
        printPageDiv.appendChild(img);

        windowObj.document.write(`
        <html>
          <head>
            <title>PrintNews</title>
          </head>
          <body>
            ${printPageDiv.innerHTML}
          </body>
        </html>
      `);

      // 인쇄 완료 후 ObjectURL 정리
      windowObj.document.querySelector('.img').onload = function () {
        windowObj.print();
        try { URL.revokeObjectURL(objectUrl); } catch(e) {}
        windowObj.document.body.innerHTML = '';
        windowObj.close();
      }
        printAlertToTrue();
        return;
      } catch (e) {
        alert('잘못된 다운로드 요청입니다.');
      }
    };
    // 실행.
    setBlobAndPrint();
  }
  // ---------------------------------------------------------------------------------------------------------------------------------------------------

  // tts 음성 듣기 버튼 -------------------------------------------------------------------------------------------------------------------------------------
  const ttsMenu = ref(false); // v-bind=volumeSliderProps로 연결된 버튼 클릭하면 true로 바뀜. false일 때 모달창 닫힘
  const audioOption = reactive({//객체와 배열 같은 복합 데이터 타입에는 reactive
    volume: 50,
    realVolume: 0.5,
    speed: 1,
    voice: "ko-KR-Standard-B",
    correctSpace: false,// 띄어쓰기 자동보정 기능 비활성화(+)
    ttsAutoPlay: false,
  });
  const isTtsPlaying = computed(()=>{
    return !isEnd.value && !isPaused.value; // tts 실행 중인 상태
  })
  watch(()=>audioOption.volume, (newVal)=>{
    userJS.volumeControl(newVal / 100);
  })
  watch(()=>audioOption.speed, (newVal)=>{
    userJS.speedControl(newVal);
  })
  watch(()=>audioOption.voice, ()=>{//음성 종류 바뀔 시엔 처음부터 다시 실행하도록
    if(isTtsPlaying.value) {// tts 실행 중
      isntEnd(true);
    } else {
      isntEnd();
    }
  })
  watch(()=>audioOption.correctSpace, ()=>{//음성 종류 바뀔 시엔 처음부터 다시 실행하도록
    if(isTtsPlaying.value) {// tts 실행 중
      isntEnd(true);
    } else {
      isntEnd();
    }
  })

  const isEnd = ref(true);
  const isPaused = ref(true);
  const selectedArticleSerial = ref('');// 선택한 기사 serial -> handleListClic()에서 사용.
  function isntEnd(withStart=false){
    userJS.stopTts();// 전 기사 실행 중지. isEnd.value = true, isPaused.value = true 처리.
    if(withStart) {
      ttsStart();
    }
  }

  async function setArticleForTts(fromTtsStart=false, isHere=false){// selectedArticleSerial.value 변경

    // 1. 북마크 선택 상태
    if (selectedScrapSeq.value != -1) {
      await changeInfoByTts();
      return true;
    }


    // 2. 북마크 선택 상태가 아닌 경우
    if (presentTtsSerial == '' && selectedArticleSerial.value == '') {// 기사 선택 없이 플레이어 버튼 클릭 시 기능
      let firstPage = _pageSideToArray.value[selectedPageIndex.value][0];

      // 현재 읽기 권한이 없는 지면의 기사 선택한 경우
      if(firstPage.idx > userStore.limitation - 1) {
        await changeInfoByTts();
        return false;
      }

      let presentPageFirstArtInfo = firstPage.Articles[0];
      selectedArticleSerial.value = presentPageFirstArtInfo.Serial;
      if(isHere) await showArticleDetailView(selectedArticleSerial.value);
    }
    if(fromTtsStart) await changeInfoByTts(fromTtsStart, isHere);

    return true;

  }
  const art = ref(null);
  const ttsArticleTitle = ref('');
  async function changeInfoByTts(fromTtsStart=false, isHere=false){// 최근 호출되기 직전 selectedSerial.value가 변경된 적이 없다면 isHere == true

    let serial = selectedArticleSerial.value || presentTtsSerial;
    if(fromTtsStart && !isHere) await showArticleDetailView(serial);

    art.value = articleDetailViewData.value;

    if(Object.keys(art.value).length === 0) {// 읽기 권한이 없는 지면 내 기사를 클릭했을 때 articleDetailViewData.value가 채워지지 않으므로... from setArticleForTts()의 2번.
      ttsArticleTitle.value = `해당 지면은 음성듣기를 지원하지 않습니다.`;
      return;
    }

    // art.value.imgType -> 자른 지면 스크랩에 대한 상세보기 창이 열린 상태에서 tts 실행하는 경우
    if(art.value.imgType) {
      ttsArticleTitle.value = `자른 지면은 음성듣기를 지원하지 않습니다.`;
    } else {
      ttsArticleTitle.value = `제목 : [${art.value.PageName}] ${art.value.Title}`;
    }

  }

  const ttsLoadingSuccess = ref(true);// true -> tts 호출 -> false -> 실제 음성 시작 -> true
  let presentTtsSerial = '';

  async function ttsStart(isHere=false) {// tts 호출 함수

    ttsLoadingSuccess.value = false;
    let setResult = false;

    if(isHere) setResult = await setArticleForTts(true, isHere);
    else setResult = await setArticleForTts(true);

    if(!setResult) {
      cancelArticleSelect();
      drawer5.value = false;
      changeInfoByTts();
      ttsLoadingSuccess.value = true;
      return;
    }

    // art.imgType : 자른 이미지 스크랩에 대한 상세보기 창이 열린 상태인 경우 - tts 실행하지 않기
    if(art.value.imgType){
      isEnd.value = true;
      isPaused.value = true;
      presentTtsSerial = '';
      ttsLoadingSuccess.value = true;
      return;
    }

    let f = new FormData();
    f.append("serial", art.value.Serial);
    f.append("voice", audioOption.voice);
    f.append("mediaSeq", mediaSeq.value);
    f.append("correctSpace ", audioOption.correctSpace);// 띄어쓰기 자동보정 기능 비활성화(-)

    audioOption.realVolume = audioOption.volume / 100;

    let isSuccess = await userJS.startTts(f, audioOption);// 통신 성공 시 true, 실패 시 false;
    if(!isSuccess) {
      isEnd.value = true;
      isPaused.value = true;
      ttsLoadingSuccess.value = true;
      keySuccessWithTts = false; // load 완료 시에만 키보드로 기사 이동 가능하도록.
    } else {
      //통신 성공 시에만!
      ttsLoadingSuccess.value = true;
      presentTtsSerial = art.value.Serial;
      isEnd.value = false;
      isPaused.value = false;
      keySuccessWithTts = true; // load 완료 시에만 키보드로 기사 이동 가능하도록.
    }

  }

  // 이전 기사로 이동 =================================[start]=================================
  async function previousArticlePage() {

    await setArticleForTts();

    // let currSerial = selectedArticleSerial.value;
    let currSerial = '';
    if(selectedArticleSerial.value == '') {// setNews() 또는 cancelArticleSelect()에 의해 ''가 됨.
      currSerial = presentTtsSerial;
    } else {
      currSerial = selectedArticleSerial.value;
    }

    let groupIdx = -1;//현재 보이는 지면의 페이지 index
    let pageIdx = -1;//현재 보이는 지면의 방향: 0(좌측) or 1(우측)
    let artIdx = -1;//현재 지면 안에서 선택된 기사의 순서

    let articles = {};//현재 지면 - 기사들 정보
    let news = _pageSideToArray.value;
    outer:
    for(let gIdx in news){
      let group = news[gIdx];
      for (let pIdx in group){
        let g = group[pIdx];
        for(let aIdx in g.Articles){
          let a = g.Articles[aIdx];
          if(a.Serial != currSerial) continue;
            groupIdx = Number(gIdx);
            pageIdx = Number(pIdx);
            artIdx = Number(aIdx);
            articles = g.Articles;
            break outer;
        }
      }
    }

    // let prevIdx = artIdx == 0 ? artIdx : artIdx-1;
    let prevIdx = artIdx-1;
    let prevSerial = '';
    function goPrevPage(){//이전 페이지 이동
      if(groupIdx == selectedPageIndex.value){//현재 화면에 띄운 지면일 때만 이동.
        selectedPageIndex.value = groupIdx-1;
      }
    }
    async function goPrevArt(groupIdx, num){//이전 지면의 마지막 기사로 이동

      let pageInfo = news[groupIdx][num];

      let articles = pageInfo.Articles;
      selectedArticleSerial.value = articles[articles.length-1].Serial;
      if(isTtsPlaying.value) {// tts 실행 중
        isntEnd(true);
      } else {
        isntEnd();
        changeInfoByTts();
      }
    }

    if(prevIdx < 0){//현재 지면의 첫번째 기사를 다 읽었다면-
      if(groupIdx == 0){//첫번째 지면이라면 더이상 이동하지 않음.
        isntEnd(!isPaused.value);
      } else {
        // 이제 이전 페이지의 기사로 넘어가자!
        // 1) 단면일 때
        if(pageSide.value == 1){
            goPrevPage();
            goPrevArt(groupIdx-1, 0);
        // 2) 양면일 때
        } else {
          //좌측 지면 다 읽으면
          if(pageIdx == 0){
            // if(news[groupIdx].length != 2) {// 통판 지면인 경우
              goPrevPage();
              goPrevArt(groupIdx-1, 1);
          //우측 지면 다 읽으면
          } else {
            goPrevArt(groupIdx, pageIdx-1);
          }
        }
      }
    } else {//현재 지면의 첫번째 기사가 아니라면-
      prevSerial = articles[prevIdx].Serial;

      selectedArticleSerial.value = prevSerial;//selectedArticleSerial.value -> watch로 감시 중.
      if(isTtsPlaying.value) {// tts 실행 중
        isntEnd(true);
      } else {
        isntEnd();
        changeInfoByTts(true);
      }
    }
  }

  function playerPrevBtn(){//이전 버튼 기능
    if(selectedScrapSeq.value != -1 // 북마크 선택상태라면 전 기사 이동 안됨.
      || selectedArticleSerial.value == '' // 어떤 기사도 선택되어 있지 않다면 기사 이동 안됨.
    ) {
      isntEnd(!isPaused.value);//기사 이동 없음
      return;
    }

    let currentTime = userJS.currentTimeTts.value;
    if (currentTime < 3) previousArticlePage();// 실행한지 3초 전 - 전 기사로 이동
    else isntEnd(!isPaused.value);//실행한지 진행도 10% 전 - 기사 이동 없음
  }
  // ================================================[end]====================================
  // 실행 및 멈춤/재실행 =================================[start]==============================
  async function ttsPlay(){
    if (isEnd.value && isPaused.value){// 현재 기사 처음부터 재생
      ttsStart(true);
    } else if(!isEnd.value){// 재생 일시 중지 <-> 일시 중지 해제
      let pauseSignal = userJS.togglePlayPause();//시작하면 false, 멈추면 true 반환.
      if (pauseSignal != null) {
        isPaused.value = pauseSignal;
      }
    }
  }
  // ================================================[end]====================================
  // 다음 기사로 이동 =================================[start]=================================
  async function nextArticlePage(autoPlay=false) {

    await setArticleForTts();
    let currSerial = '';
    if(selectedArticleSerial.value == '') {// setNews() 또는 cancelArticleSelect()에 의해 ''가 됨.
      currSerial = presentTtsSerial;
    } else {
      currSerial = selectedArticleSerial.value;
    }

    let groupIdx = -1;//현재 보이는 지면의 페이지 index
    let pageIdx = -1;//현재 보이는 지면의 방향: 0(좌측) or 1(우측)
    let artIdx = -1;//현재 지면 안에서 선택된 기사의 순서

    let articles = {};//현재 지면 - 기사들 정보
    let pageLength = 0;//현재 지면의 기사 개수
    let news = _pageSideToArray.value;
    outer:
    for(let gIdx in news){
      let group = news[gIdx];
      for (let pIdx in group){
        let g = group[pIdx];
        for(let aIdx in g.Articles){
          let a = g.Articles[aIdx];
          if(a.Serial != currSerial) continue;
            groupIdx = Number(gIdx);
            pageIdx = Number(pIdx);
            artIdx = Number(aIdx);
            articles = g.Articles;
            pageLength = articles.length;
            break outer;
        }
      }
    }

    let nextIdx = artIdx+1;
    let nextSerial = '';
    function goNextPage(){// 다음 페이지 이동
      if(groupIdx == selectedPageIndex.value){// 현재 화면에 띄운 지면일 때만 이동
        selectedPageIndex.value = groupIdx+1;
      }
    }
    async function goNextArt(groupIdx, num){// 다음 지면 이동
      let pageInfo = news[groupIdx][num];

      let idx = pageInfo.idx || 0;
      let limit = userStore.limitation || 100;
      if( idx >= limit ) {
        isntEnd();
        cancelArticleSelect();
        presentTtsSerial = '';
        articleDetailViewData.value = {};
        drawer5.value = false;
        changeInfoByTts();
        isAccessDeniedOverlayOn.value = true;
        return false;
      }

      selectedArticleSerial.value = pageInfo.Articles[0].Serial;// selectedArticleSerial.value -> watch로 감시 중.
      if(autoPlay) isntEnd(true);// 다음기사 자동 재생으로 넘어온 경우.
      else {
        if(isTtsPlaying.value) {// tts 실행 중
          isntEnd(true);
        } else {
          isntEnd();
          changeInfoByTts(true);
        }
      }
    }

    if(nextIdx > (pageLength-1)){//현재 지면의 마지막 기사를 다 읽었다면-
      if(groupIdx == news.length-1){//마지막 지면이라면 더이상 이동하지 않음.
        isntEnd(!isPaused.value);
      } else {
        // 이제 다음 페이지의 기사로 넘어가자!
        // 단면일 때
        if(pageSide.value == 1){
          goNextPage();
          goNextArt(groupIdx+1, 0);
        // 양면일 때
        } else {
          //좌측 지면 다 읽으면
          if(pageIdx == 0){
            if(news[groupIdx].length != 2) {// 통판 지면인 경우
              goNextPage();
              goNextArt(groupIdx+1, 0);
            } else {
              goNextArt(groupIdx, pageIdx+1);
            }
          //우측 지면 다 읽으면
          } else {
            goNextPage();
            goNextArt(groupIdx+1, 0);
          }
        }
      }
    } else {//현재 지면의 마지막 기사가 아니라면-
      nextSerial = articles[nextIdx].Serial;

      selectedArticleSerial.value = nextSerial;//selectedArticleSerial.value -> watch로 감시 중.
      if(autoPlay) isntEnd(true);// 다음기사 자동 재생으로 넘어온 경우.
      else {
        if(isTtsPlaying.value) {// tts 실행 중
          isntEnd(true);
        } else {
          isntEnd();
          changeInfoByTts(true);
        }
      }
    }
  }
  function goArticlePage_Manual(){// 자동 재생 상태 아닐 때.

    // 북마크 선택상태라면 해당 기사만 tts 실행 가능!
    // 자른 지면 북마크의 경우 handListClick()에서 변경되는 isCuttingScrap 값이 true인 경우 비활성화 처리하고 있음.
    if(selectedScrapSeq.value != -1
      || selectedArticleSerial.value == '' // 아무 기사도 선택되어 있지 않다면 기사 이동 안됨.
    ){
      return;
    }

    nextArticlePage();//다음 기사 tts 실행
  }
  function goArticlePage_Auto() {// 자동 재생 상태일 때.
    if ( !audioOption.ttsAutoPlay ) return;
    if ( selectedScrapSeq.value != -1 ) return; // 북마크 선택 상태 - 북마크 읽을 때는 자동 재생 무조건 안됨!
    nextArticlePage(true);//다음 기사 tts 실행
  }
  // ================================================[end]====================================
  // 진행도/시간 보여주기 & 조절하기 ==================[start]==================================
  const progress = ref(userJS.progress.value);//진행도
  const ttsDragging = ref(false);
  function startDragging(){
    ttsDragging.value = true;
  }
  function onDragging(){
    if(!ttsDragging.value) return;
    userJS.setPosition(progress.value); // 드래그 또는 클릭으로 tts 진행도 변경.
    ttsDragging.value = false;
  };
  watch(userJS.progress, (newVal)=>{
    if(!ttsDragging.value) {// 드래그 중에는 화면에 실시간 진행도 반영 안 되도록.
      progress.value = newVal;
    } else {
      if(newVal == 0 || newVal == 100) {
        progress.value = newVal;
      }
    }
  })

  function formatTime(seconds) {
    if (isNaN(seconds)) seconds = 0;
    let mm = Math.floor(seconds / 60);
    let ss = Math.floor(seconds % 60);
    return `${mm}:${ss < 10 ? '0' : ''}${ss}`;
  }
  let currentTimeTts = ref(formatTime(userJS.currentTimeTts.value));//진행 시간
  let durationTts = ref(formatTime(userJS.durationTts.value));// 총 읽기 시간
  watch(userJS.currentTimeTts, ()=>{
    currentTimeTts.value = formatTime(userJS.currentTimeTts.value);
    durationTts.value = formatTime(userJS.durationTts.value);
  })

  // ================================================[end]====================================

  // 매체(종판/초판/..) 선택 버튼 -----------------------------------------------------------------------------------------------------------------------
  const roleSelection = ref(userStore.$getAndSetEditionSeq());// 초기 - 종판 seq

  // (매체별 발행 년도 배열 ==) publicationYears 정규화 (store에서 꺼내 숫자 배열로 반환)
  function _normalizePublicationYears(mediaSeqKey) {
    const raw = userStore.$getRole()[mediaSeqKey]?.publicationYears;
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : [raw];
    return [...new Set(arr.map(y => Number(y)).filter(y => !isNaN(y) && y > 0))].sort((a, b) => a - b);
  }
  // (매체별 발행 년도 배열 ==) publicationYears 배열 기준으로 이동 가능한 최적 발행일자 탐색
  // returns { ymd: 'yyyyMMdd', alertMsg: string|null } | null
  async function _findTargetYmd(currentPickerYmd, publicationYearsArr, targetMediaSeq) {
    const currentPickerYear = Number(currentPickerYmd.slice(0, 4));
    const mdName = userStore.$getRole()[targetMediaSeq]?.mdName || ''; // mediaSeq에 해당하는 매체 이름. alertMsg에 사용하기 위함.

    function _fmt(ymd) {
      return `${ymd.slice(0,4)}-${ymd.slice(4,6)}-${ymd.slice(6,8)}`;
    }

    async function _fetchDates(year) {
      suppressApiAlert.value = true;
      try {
        const params = new URLSearchParams();
        params.append('date', String(year));          // 숫자를 문자열로 직접 변환
        params.append('mediaSeq', targetMediaSeq);    // 외부 함수의 targetMediaSeq 사용
        const res = await userJS._api.getDates(params);
        return (res && res.length > 0) ? res.map(e => e.date) : [];
      } catch { return []; }
      finally { suppressApiAlert.value = false; }
    }

    // 현재 선택 연도가 publicationYears 배열에 포함되는 경우
    if (publicationYearsArr.includes(currentPickerYear)) {
      const yearDates = await _fetchDates(currentPickerYear);

      if (yearDates.length > 0) {
        // 현재 선택일이 발행일 목록에 있으면 그대로
        if (yearDates.includes(currentPickerYmd)) {
          return { ymd: currentPickerYmd, alertMsg: null };
        }

        // [1] 현재 선택일보다 이전인 가장 가까운 발행일 (같은 연도 내)
        const prevYmds = yearDates.filter(d => d < currentPickerYmd).sort();
        if (prevYmds.length > 0) {
          const targetYmd = prevYmds[prevYmds.length - 1];
          return {
            ymd: targetYmd,
            alertMsg: `선택한 날짜(${_fmt(currentPickerYmd)})가\n선택한 매체(${mdName})의 발행 날짜가 아닙니다.\n대신 발행 날짜 범위(${publicationYearsArr.join(', ')}) 내에서 선택한 날짜(${_fmt(currentPickerYmd)})와\n가장 가까운 이전 날짜(${_fmt(targetYmd)})로 이동합니다.`,
          };
        }
      }

      // [2] 같은 연도 내 이전 발행일 없음 → 이전 연도 내림차순 탐색 성공
      const prevYears = publicationYearsArr.filter(y => y < currentPickerYear).sort((a, b) => b - a);
      for (const year of prevYears) {
        const dates = await _fetchDates(year);
        if (dates.length > 0) {
          const targetYmd = dates[dates.length - 1];
          return {
            ymd: targetYmd,
            alertMsg: `선택한 날짜(${_fmt(currentPickerYmd)})가\n선택한 매체(${mdName})의 발행 날짜가 아닙니다.\n대신 발행 날짜 범위(${publicationYearsArr.join(', ')}) 내에서\n선택한 날짜(${_fmt(currentPickerYmd)})와\n가장 가까운 이전 날짜(${_fmt(targetYmd)})로 이동합니다.`,
          };
        }
      }

      // [3] 현재 선택일보다 이후인 가장 가까운 발행일 (같은 연도 내)
      if (yearDates.length > 0) {
        const nextYmds = yearDates.filter(d => d > currentPickerYmd).sort();
        if (nextYmds.length > 0) {
          const targetYmd = nextYmds[0];
          return {
            ymd: targetYmd,
            alertMsg: `선택한 날짜(${_fmt(currentPickerYmd)})가\n선택한 매체(${mdName})의 발행 날짜가 아닙니다.\n대신 발행 날짜 범위(${publicationYearsArr.join(', ')}) 내에서 선택한 날짜(${_fmt(currentPickerYmd)})와\n가장 가까운 이후 날짜(${_fmt(targetYmd)})로 이동합니다.`,
          };
        }
      }


      // [4] 이전 연도도 없음 → 이후 연도 오름차순 탐색 성공
      const nextYears = publicationYearsArr.filter(y => y > currentPickerYear).sort((a, b) => a - b);
      for (const year of nextYears) {
        const dates = await _fetchDates(year);
        if (dates.length > 0) {
          const targetYmd = dates[0];
          return {
            ymd: targetYmd,
            alertMsg: `선택한 날짜(${_fmt(currentPickerYmd)})가\n선택한 매체(${mdName})의 발행 날짜가 아닙니다.\n대신 발행 날짜 범위(${publicationYearsArr.join(', ')}) 내에서\n선택한 날짜(${_fmt(currentPickerYmd)})와\n가장 가까운 날짜(${_fmt(targetYmd)})로 이동합니다.`,
          };
        }
      }

      return null;
    }

    // [5-a] 현재 선택 연도가 publicationYears 배열에 포함되지 않는 경우 - 이전 날짜로 먼저 이동
    const prevYears = publicationYearsArr.filter(y => y < currentPickerYear).sort((a, b) => b - a);
    for (const year of prevYears) {
      const dates = await _fetchDates(year);
      if (dates.length > 0) {
        const targetYmd = dates[dates.length - 1];
        return {
          ymd: targetYmd,
          alertMsg: `선택한 날짜(${_fmt(currentPickerYmd)})가\n선택한 매체(${mdName})의 발행 날짜 범위(${publicationYearsArr.join(', ')})에 포함되지 않습니다.\n대신 발행 날짜 범위 내에서 선택한 날짜와 가장 가까운 이전 날짜(${_fmt(targetYmd)})로 이동합니다.`,
        };
      }
    }

    // [5-b] 현재 선택 연도가 publicationYears 배열에 포함되지 않는 경우 - 이후 날짜로 이동
    const nextYears = publicationYearsArr.filter(y => y > currentPickerYear).sort((a, b) => a - b);
    for (const year of nextYears) {
      const dates = await _fetchDates(year);
      if (dates.length > 0) {
        const targetYmd = dates[0];
        return {
          ymd: targetYmd,
          alertMsg: `선택한 날짜(${_fmt(currentPickerYmd)})가\n선택한 매체(${mdName})의 발행 날짜 범위(${publicationYearsArr.join(', ')})에 포함되지 않습니다.\n대신 발행 날짜 범위 내에서 선택한 날짜와 가장 가까운 날짜(${_fmt(targetYmd)})로 이동합니다.`,
        };
      }
    }

    return null;
  }

  async function changeRoleSelection(mdName) {
    if (isPageLoading.value) return;
    isPageLoading.value = true;
    pageLoadingType.value = 'media';
    pageLoadingMessage.value = '매체가 변경되어 지면 이미지 갱신 중입니다...';

    // ── 롤백용 스냅샷 ──────────────────────────────────────────────────
    const prevMediaSeq      = mediaSeq.value;
    const prevMediaCode     = mediaCode.value;
    const prevDatepicker    = datepicker.value;
    const prevYear          = selectedYear.value;
    const prevMonth         = selectedMonth.value;
    const prevDay           = selectedDay.value;

    const newMediaSeq = userStore.$getAndSetEditionSeq(mdName);
    if (!newMediaSeq) return;

    // ── STEP 1: /paperPublicationYears 호출 → 새 매체의 publicationYears를 store에 갱신 ──────────
    // userJS._api.postPublicationYears(mediaSeq)의 response: { result : {success: true, publicationYears : string[]|number[] } }
    suppressApiAlert.value = true;
    let newPublicationYearsArr;

    try {
      let params = new FormData();
      params.append('mediaSeq', newMediaSeq);
      params.append('date', datepicker.value.format('yyyy'));

      const res = await userJS._api.postPublicationYears(params);

      if (!res || !res.publicationYears) {
        alert('해당 매체의 발행 연도 정보를 불러오지 못했습니다.');
        return;
      }
      newPublicationYearsArr = userStore.$setPublicationYears(newMediaSeq, res.publicationYears);
      if (!newPublicationYearsArr.length) {
        alert(`해당 매체의 발행 연도 정보가 올바르지 않습니다.`);
        return;
      }
    } catch (e) {
      console.error('/newApi(publicationYears) 호출 오류:', e);
      alert('해당 매체의 발행 연도 정보를 불러오는 중 오류가 발생했습니다.');
      return;
    } finally {
      suppressApiAlert.value = false;
      isPageLoading.value = false;
    }

    // ── STEP 2: 새 매체 정보 임시 적용 ────────────────────────────────
    mediaSeq.value  = newMediaSeq;
    mediaCode.value = userStore.mediaRole[newMediaSeq].mdOid;

    // ── STEP 3: 이동 가능한 발행일자 탐색 ─────────────────────────────
    const currentPickerYmd = datepicker.value.format('yyyyMMdd');
    let result;
    try {
      isPageLoading.value = true;
      pageLoadingType.value = 'media';
      pageLoadingMessage.value = '매체가 변경되어 지면 이미지 갱신 중입니다...';
      result = await _findTargetYmd(currentPickerYmd, newPublicationYearsArr, newMediaSeq);
    } catch (e) {
      console.error('날짜 탐색 중 오류:', e);
      result = null;
    }

    if (!result) {
      alert('해당 매체에 발행 일자 정보가 없습니다.');
      // 롤백
      mediaSeq.value  = prevMediaSeq;
      mediaCode.value = prevMediaCode;
      isPageLoading.value = false;
      pageLoadingType.value = '';
      pageLoadingMessage.value = '';
      return;
    }

    if (result.alertMsg) alert(result.alertMsg);

    // ── STEP 4: datepicker 갱신 + getPublicationDate 호출 ─────────────
    const targetDate      = makeDateFromYmd(result.ymd);
    const needDateChange  = currentPickerYmd !== result.ymd;

    if (needDateChange) {
      isSyncingRoleDatepicker = true;       // watcher 중복 실행 방지
      datepicker.value = targetDate;
    }

    const ok = await getPublicationDate(targetDate);

    if (ok) {
      // 최종 반영
      roleSelection.value   = newMediaSeq;
      selectedMdName.value  = mdName;
      mediaName.value       = userStore.mediaRole[newMediaSeq].paperName;
    } else {
      // 롤백
      mediaSeq.value        = prevMediaSeq;
      mediaCode.value       = prevMediaCode;
      if (needDateChange) {
        isPageLoading.value       = true;
        datepicker.value     = prevDatepicker;
      }
      selectedYear.value  = prevYear;
      selectedMonth.value = prevMonth;
      selectedDay.value   = prevDay;

      // 롤백 시 로딩 상태 완전 초기화
      isPageLoading.value    = false;
      pageLoadingType.value  = '';
      pageLoadingMessage.value = '';
    }
  }

  async function getLoginInfo(){// 사용자마다 설정된 권한 - 적용해주는 함수. onMounted()에서 실행.
    let getMediaRole = userStore.mediaRole;

    // 확인용
    // console.log(JSON.stringify(getMediaRole));

    // ================================================================

    mediaSeq.value = roleSelection.value;
    mediaCode.value = getMediaRole[roleSelection.value].mdOid;
    mediaName.value = getMediaRole[roleSelection.value].paperName;

    accountId.value = userInfoStore.userName;
    logoUrl.value = userInfoStore.LOGO;
  }

  // 모바일 화면에서 보이는 '기능 더보기 버튼' -----------------------------------------------------------------------------------------------------------
  const moreFuncYn = ref(false);
  const iscuttingUser = ref(true);

  // --------------------------------------------------------------------------------------------------------------------------------------------------

  // 기사 목록 -----------------------------------------------------------------------------------------------------------------------------------------

  // 기사 목록 열기 결정 배열
  const open = ref([]);

  function setArticleListOpenGroup(serial) {
    // 페이지가 배열에 있는지 확인
    const pageIndex = open.value.indexOf(serial);
    // 페이지가 배열에 있을 때
    if (pageIndex !== -1) {
      // 해당 페이지를 배열에서 제거
      open.value.splice(pageIndex, 1);
    } else {
      // 기사 목록 열린 상태 여부 결정하는 배열.
      open.value.push(serial);
    }
  };

  /**
  * script 내부 함수들 묶음
  * @function sideChange(array) - 양/단면 변경시 공통 함수
  */
  let _func = {
    // 썸네일 + 양면인 경우 1면, 마지막 면, 면 이름이 알파벳으로 시작하는 면의 속지는 template 코드로만 구현하고 있음.
    sideChange: function(array) {
      let bef = array.slice();
      let clone = [];
      let idx = 0;
      for (const val of bef) {
        val.idx = idx++;
        if (val.doublepage)// val.doublepage == true인 경우(통판 지면) 그 다음 페이지 부터 idx에 1씩 +
          idx++;
        clone.push(JSON.parse(JSON.stringify(val)));
      }
      let arr = [];

      let last;
      if (pageSide.value == 2) {
        last = [clone.pop()];
        arr.push([clone.shift()]);
      }
      while(clone.length > 0){
        // arr.push( clone.splice(0, clone[0].doublepage ? 1 : clone.forEach(e => e.localpage) : pageSide.value) );
        arr.push( clone.splice(0, clone[0].doublepage || clone[0].localpage || clone[0].isNextLocalpage ? 1 : pageSide.value) );// 통판, 지역지면 여부에 따라 바뀜.
      }
      if (pageSide.value == 2) {
        arr.push(last);
      }
      return arr;
    }
  }

  const newsImages = ref([]);
  const _pageSideToArray = ref([]); // 단/양면에 따른 이미지 그룹
  const selectedMdName = ref(userStore.mediaRole[Object.keys(userStore.mediaRole)[0]]['mdName']);

  // API -> 기사목록 데이터 + 기사목록 열린 상태 배열 'open' + openseadragon 라이브러리로 띄울 이미지 주소 생성하기
  async function showArticleList(serial) {
    try {
      // 1) 기사 목록 및 이미지 주소 데이터 불러오기
      let params = new URLSearchParams();
      params.append('serial', serial);
      params.append('mediaSeq', mediaSeq.value);
      const res = await userJS._api.paperInfo.few(params);
      if (res) {
        if(res.PageList == '' || res.ArticleList == '') {//해당 serial에 대한 기사 정보가 없을 때는 빈문자열 반환
          // alert(`${selectedMdName.value} 지면 정보가 없습니다.`);
          newsImages.value = [];
          return;
        }
        let pages = res.PageList.Page;
        let Articles = res.ArticleList.Article.slice();
        params = new URLSearchParams();
        params.append('mediaSeq', mediaSeq.value);
        let original_pdf_height = "";
        let original_pdf_width = "";
        pages.map((page, i, safe) => {
          params.set('filepath', `${page.Serial}`);
          page.url = `${userJS.baseUrl}/paperDown?${params.toString()}`;
          params.set('filepath', `${page.Serial}thm`);
          page.src = `${userJS.baseUrl}/paperDown?${params.toString()}`;

          if(!i) page.firstpage = true;// 1면 이다.
          else if (i == pages.length - 1) page.lastpage = true;// 마지막 면이다.

          // 20250918 최지현 - 별지/지역지면 관련 기능 일단 주석처리
          // if( isNaN(page.Serial.substring(page.Serial.length - 3)) ){// 지역지면 이다.
          //   let pos1 = i == 0 ? i : i - 1;
          //   if( !isNaN(safe[pos1].Serial.substring(safe[pos1].Serial.length - 3)) ) safe[pos1].isNextLocalpage = true;// 지역 지면 바로 앞 (지역 지면이 아닌) 페이지다.
          //   page.localpage = true;
          // }
          let serials = page.ArticleSerial.Serial;

          // 20250924 최지현 - 통판인 상황 하나 더 고려해서 처리되도록.
          // if(i == 0){
          //   original_pdf_height = page.Pdf_height;
          //   original_pdf_width = page.Pdf_width;
          // }
          // if( original_pdf_height == page.Pdf_width && original_pdf_width == page.Pdf_height ){ // 통판 이다.
          //   safe[i].doublepage = true;
          //   return true;
          // }

          if( serials === '0'){ // 통판 이다.
            let pos2 = i == 0 ? i : i - 1; // serials === '0'인 통판이라면, 바로 전 지면 정보에 해당 통판에 있는 기사 정보가 있기 때문에 -1 하기.
            safe[pos2].doublepage = true;
            safe[pos2].Name = `${safe[pos2].Name}~${safe[i].Name}`;
            return true;
          }

          if( !Array.isArray(serials) ) serials = [serials];

          // page.Articles = Articles.splice(0, serials.length);
          // 20250923 최지현 - 매체사 관리자 페이지에서 지면 순서를 변경함에 따라,
          // 면 순서가 바뀌어도 각 면에 정확한 기사 정보를 배치하기 위함.
          const firstIndex = Articles.findIndex(article=>page.Serial == article.Serial.slice(0, -3));
          page.Articles = Articles.splice(firstIndex, serials.length);
        });
        newsImages.value = pages.filter(art => art.ArticleSerial.Serial !== '0');//통판(후면) 정보 미포함 - 기사 목록 관련
        _pageSideToArray.value = _func.sideChange(newsImages.value);
        // 모든 페이지의 Serial 값을 open 배열에 포함 - 기사목록 - 리스트 - 그룹 열린 상태 설정
        open.value = pages.map(page => page.Serial);
        allSerial.value = open.value.slice();
        selectedPageIndex.value = 0;
        setForSidePageTwo(true);// 지면 자르기 버튼 활성화 여부 결정
      }
    } catch (error) {
      throw error;
    }
  }

  // 양/단면 모드 상태
  const pageSide = ref(1);
  watch(pageSide, ()=>{
    _pageSideToArray.value = _func.sideChange(newsImages.value);
    // 양면 <-> 단면으로 변경 시
    let idx = -1;
    let news = _pageSideToArray.value;
    outer: for (let pIdx in news) {
      const aList = news[pIdx];
      for (let a of aList) {
        if (a.Serial == selectedArticleGroupSerial.value) {
          idx = Number(pIdx);
          break outer;
        }
      }
    }
    if (idx !== -1) selectedPageIndex.value = idx;
  })

  let selectedPageIndex = ref(0);// 초기에 아무것도 선택되지 않은 상태 index -> OpenSeadragon의 initialPage와 같아야함. 첫 페이지를 의미.
  /**
   * component @click에서 사용될 함수들
   * @function preNext(number) - 이전 / 다음 기사
   * @function toTargetPage(where) - 첫 면/마지막 면으로 이동
   * @function togglePageSideOption(boolean) - 양/단면 보기 옵션 토글 버튼 기능
  **/
  const setupFunc = reactive({
    preNext: function(upDw=-1) {
      let nowIdx = selectedPageIndex.value + upDw;
      const max = _pageSideToArray.value.length;
      if( nowIdx == max || nowIdx == -1 ) return;// 맨 첫번째, 마지막 지면에서 버튼 클릭 비활성화
      selectedPageIndex.value += upDw;
      setupFunc.togglePageSideOption(false);
      selectedArticleGroupSerial.value = _pageSideToArray.value[selectedPageIndex.value][0].Serial;
    },
    toTargetPage: function(where=0) {
      if(!where) selectedPageIndex.value = 0; // 첫 면으로 이동
      if(where) selectedPageIndex.value =_pageSideToArray.value.length-1; // 마지막 면으로 이동
      selectedArticleGroupSerial.value= _pageSideToArray.value[selectedPageIndex.value][0].Serial;
    },
    togglePageSideOption: function(toggle=true) {
      if( toggle ) pageSide.value = pageSide.value%2 + 1;
      //console.log(_pageSideToArray.value);

    },
  });

  // 지면 이동 함수
  function moveNewsPaper(serial){
    let pageSerial = serial.substring(0, 15);
    let gIdx = _pageSideToArray.value.findIndex(pair => pair.some(p=>p.Serial == pageSerial));
    if(selectedPageIndex.value != gIdx){
      selectedPageIndex.value = gIdx;// watch로 감시중 -> selectedPageIndex 변경 시 면(페이지) 이동.
    }
    // nestedDrawer.vue의 자동 스크롤 autoScroller()
    selectedArticleGroupSerial.value = pageSerial;
  }

  // emit from ArticleDetailView.vue의 상세보기 창 닫기 버튼 기능
  function cancelArticleSelect(){
    // if(mobile.value) return;// 모바일에서는 비활성화

    const isScrapControl = selectedScrapSeq.value != -1 && tab.value == 'option-3' && nestedDrawer.value;
    const isTtsLoading = art.value && !ttsLoadingSuccess.value;// 다음으로 실행시킬 기사에 대해 tts 로딩 중 상태

    // 북마크 선택 중이 아닐 때 && ( tts 실행 중 또는 tts 실행 전 로딩 중)이라면,
    // 현재 tts 실행 중인 기사 선택 상태는 유지하도록 -> 상세보기 창 꺼져있는 상태더라도 tts 이전/다음 버튼에 의해 이전/다음 기사로 이동 가능하도록 하기 위하여!
    if(!isScrapControl && (isTtsPlaying.value || isTtsLoading)) return;

    selectedArticleSerial.value = '';
    selectedArticleGroupSerial.value = '';

    if(isScrapControl) {
      nestedDrawer.value = false;// 북마크 기사에 대한 상세보기 창 닫을 때 -> 북마크 좌측 헤더도 닫히도록.
      tab.value = '';
    }
  }

  // 기사 목록 - 기사 선택 시 기능 구현
  const selectedArticleGroupSerial = ref('');

  // 북마크 선택 상태
  const selectedScrapSeq = ref(-1);
  function changeSelectedScrapSeq(seq){ // emit from NestedDrawer.vue or handleListClick()
    selectedScrapSeq.value = seq;
  }

  // 기사 상세보기 창 안 보여줄 때 (userStore.limitation이 있을 때)
  const isAccessDeniedOverlayOn = ref(false);
  const isCuttingScrap = ref(false);

  function getMobileEnabled(from) {
    if(from == 'articleList'){
      if(userMobileStore.leftSidebar.$isDetailViewEnabledFromLeft) return true;
    }
    if(from == 'newsImage'){
      if(userMobileStore.paperCenterImage.$isDetailViewEnabledFromCenter) return true;
    }
    //if(from == 'searchResult' && '...')  return true; // 추후 기사 검색 결과 및 북마크 클릭 시 상세보기 창 띄우는 기능 막을 때 추가하기 - 미구현
    return false;
  };

  // scrapInfo !== undefined -> 북마크 리스트에서 진입 시
  // from = 'articleList' -> 기사 목록에서 진입 시 (구현)
  // from = 'newsImage' -> 지면 이미지에서 진입 시 (구현)
  // from = 'searchResult' -> 검색 결과에서 진입 시 (미구현)
  async function handleListClick(serial, idxInfo=undefined, scrapInfo=undefined, from = 'articleList') {
    isCuttingScrap.value = scrapInfo && scrapInfo.imgType == 2;// 북마크 리스트에서 자른 지면 북마크 클릭하여 들어옴.

    if(!isCuttingScrap.value && articleDetailViewData.value.Serial == serial) {
      if(!drawer5.value || tab.value == 'option-3' ) {
        drawer5.value = true;
        if(!scrapInfo) {
          selectedArticleSerial.value = serial;
          selectedArticleGroupSerial.value = serial.slice(0, -3);
          selectedScrapSeq.value = -1;
        } else {
          selectedArticleSerial.value = '';
          selectedArticleGroupSerial.value = '';
          selectedScrapSeq.value = scrapInfo.scrapSeq;
        }
      }
      return;
    }

    if(!scrapInfo) {// 기사목록-리스트, 지면 이미지, 검색 결과 클릭 시
      // 1) 지면 페이지 이동
      moveNewsPaper(serial);
      // 2) selectedArticleGroupSerial 값 변경
      selectedArticleSerial.value = serial;
      selectedScrapSeq.value = -1;
    } else {// 3) 북마크 선택한 경우 -> 북마크 선택 상태로 CSS변경 및 북마크 기사 대상으로 tts 실행 가능.
      selectedArticleSerial.value = '';
      selectedArticleGroupSerial.value = '';
      selectedScrapSeq.value = scrapInfo.scrapSeq;
    }

    if( !idxInfo && !scrapInfo) {// 검색 결과 클릭 시
      const article = newsImages.value.find(article => article.Serial == serial.substring(0, 15));
      if (article) idxInfo = article.idx;
    }

    // 4) 상세보기 페이지
    if(userStore.limitation
      && (idxInfo && idxInfo > userStore.limitation-1  // limitation 값 이후는 상세보기 창 열람 권한 없음.
      && scrapInfo == undefined)) {// 북마크 클릭 시 - limitation과 상관없이 기사 상세보기 창 볼 수 있도록.
        cancelArticleSelect();
        articleDetailViewData.value = {};
        changeInfoByTts();
        drawer5.value = false;
        isAccessDeniedOverlayOn.value = true;
    } else {
        // 모바일 - 좌측 기사 목록 탭 - 기사 선택 시 상세보기 창 여는 기능을 활성화/비활성화
        const mobileEnabled = getMobileEnabled(from);
        if(mobileEnabled) {
          // 20250918 최지현 - 별지 포함 링크에 의해 페이지 이동 시 상세보기 창 열지 않도록! start =====
          if(userStore.localpageSerial == '') {
            drawer5.value = true;
          }
          await showArticleDetailView(serial, scrapInfo); // 기사 상세보기 정보를 불러와야 tts 실행 가능.
        }
        // ======================================================================= end ======
    }

    // 5) tts 관련
    if(serial == presentTtsSerial) return;// 기존 tts가 실행된 기사 눌렀을 때.
    if(isTtsPlaying.value) {// tts 실행 중
      if(!scrapInfo && idxInfo > userStore.limitation-1){
        presentTtsSerial = '';
        isntEnd();
        return;
      }
      isntEnd(true);
    } else {
      isntEnd();
      changeInfoByTts();
    }

  };

  // 지면 이미지 저장 버튼 기능 --------------------------------------------------------------------------------------------------------------------------
  // 양면일 경우 두 지면 중 선택할 수 있도록 하는 기능(+)
  const serialsForPrint = ref([]);
  const presentPageSerial = ref('');
  const imageDownloadSelection = ref('low'); // 저(low), 중(medium), 고(high), 원본(original)
  // 지면 이미지 다운로드 기능
  async function downloadNewsImage(imageQuality, imageType) {

    /* 아이폰으로 다운로드 시 안 되도록 막기 */
    if(userJS.checkMobile() == 'ios') {
      userAlertStore.$resetAllAlert();
      imgDownloadAlertToTrue('', true);
      return;
    }

    let imgQuality = '';
    let imgType = 0;//0: 지면, 1: 기사, 2: 자르기
    let serial = '';
    let filename = '';
    /* 변수 세팅 */
    const EXIST_PARAM = (imageQuality && imageType ? true : false);
    if (EXIST_PARAM) {//기사 상세보기 창에서 기사 이미지 다운로드
      imgQuality = imageQuality;
      imgType = imageType;
      serial = articleDetailViewData.value.Serial;
    } else {//header에서 지면 이미지 다운로드
      imgQuality = imageDownloadSelection.value
      imgType = 0;
      if (pageSide.value == 1)// 단면
        serial = _pageSideToArray.value[selectedPageIndex.value][0].Serial;
      else// 양면
        serial = presentPageSerial.value;
    }
    /* 파일 이름 생성 */
    let imgQualityName = imgQuality == 'high' ? '-고화질' : imgQuality == 'medium' ? '-중화질' : imgQuality == 'low' ? '-저화질' : imgQuality == 'original' ? '-원본' : '';
    switch(imgType) {
      case 1:
      case 2:
        filename = `-${articleDetailViewData.value.Title.replaceAll(".", "_")}`;
      case 0:
        filename = `${mediaName.value}-${serial.substring(0, 8)}${imgQualityName}-${serial.substring(12, 15)}면${filename}`;
        break;
      default :
        console.error("Set filename error");

    }
    /* 화질 선택 */
    if(imgQuality == 'low') {
      serial = serial+'p30';
    } else if(imgQuality == 'medium') {
      serial = serial+'p70';
    }

    let imageAPIUrl = '';

    if(imgType && imgType == 2) { // cutting 스크랩 이미지 불러오기
      imageAPIUrl = `${userJS.baseUrl}/user/scrap/cutDown/${articleDetailViewData.value.filename}`
    } else {
      let params = new URLSearchParams();
      params.append('filepath', serial);
      params.append('mediaSeq', mediaSeq.value);
      params.append('imgType', imgType);
      imageAPIUrl = `${userJS.baseUrl}/paperDown/desktop?${params.toString()}`;
    }

    await axios.get(imageAPIUrl, {
      responseType: 'blob',
      withCredentials: true,           // 인터셉터/쿠키 필요 시
    }).then(async ({ data: blob, status, headers }) => {
      if (status === 200) {
        // 1) 혹시 서버가 JSON(에러) 내려보냈는지 확인
        const ctype = headers?.['content-type'] || blob.type || '';
        if (ctype.includes('application/json')) {
          try {
            const text = await blob.text();
            const json = JSON.parse(text);
            console.log(json.message || json.msg || '잘못된 다운로드 요청입니다.');
            return;
          } catch {
            console.log('잘못된 다운로드 요청입니다.');
            return;
          }
        }

        // 2) 정상 이미지: Blob → ObjectURL로 a[href]에 부여
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();// 브라우저가 자동으로 GET 요청을 보내 이미지 파일 다운로드
        document.body.removeChild(link);
        try { URL.revokeObjectURL(objectUrl); } catch {}

        // 모바일인 경우 알림창 띄우지 않기
        if (/android|webos|iphone|ipad|ipod|macintosh|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) return;
        /* 알림창 띄우기 */
        userAlertStore.$resetAllAlert();
        imgDownloadAlertToTrue(filename);

      } else {
        alert('잘못된 다운로드 요청입니다.');
      }
    })
    .catch(error => {
      // status 404, 500, ..
      alert('잘못된 다운로드 요청입니다.', error);
    });

  }

  // ================== [START] ==================
  // 최대화 버튼 기능
  // 반응형으로 homeBtn 버튼 실행 시 사용하는 변수
  const isFullScreen = ref(false);// PaperCenter.vue에서 사용.

  function openFullScreen() {
    const el = document.documentElement;
    if (el.requestFullscreen) el.requestFullscreen();
    else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
    else if (el.msRequestFullscreen) el.msRequestFullscreen();
  }

  function closeFullScreen() {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    else if (document.msExitFullscreen) document.msExitFullscreen();
  }

  // 이 함수만 버튼에서 직접 호출하게!
  function onClickFullScreen() {
    if (document.fullscreenElement) {
      closeFullScreen();
      isFullScreen.value = false;
    } else {
      openFullScreen();
      isFullScreen.value = true;
    }
  }
  // ================== [END] ==================

  // 이미지 다운로드 관련
  // 이미지 자르기 관련
  // 기능 현재 면 정보, 사용자가 선택한 면 정보 설정 기능.
  const allSerial = ref([]);
  function setForSidePageTwo(isCutting=false){// 양면 - header에서 이미지 다운로드 버튼 클릭 이벤트.
    serialsForPrint.value = _pageSideToArray.value[selectedPageIndex.value];// 단-양면 변경 때마다 지면정보 담기
    if(userStore.limitation) {
      allSerial.value = allSerial.value.slice(0, userStore.limitation).map(e => e);// 제한되지 않은 기사 serial 배열.
    }
    // userStore.limitation에 의해 열람 불가능한 지면 '저장' 버튼 막히도록!
    if(!isCutting){
      presentPageSerial.value = allSerial.value.includes(serialsForPrint.value[0].Serial) ? serialsForPrint.value[0].Serial : '';
    } else {
      presentCuttingPageSerial.value = allSerial.value.includes(serialsForPrint.value[0].Serial) ? serialsForPrint.value[0].Serial : '';
      presentCuttingPageUrl = allSerial.value.includes(serialsForPrint.value[0].Serial) ? serialsForPrint.value[0].url+'p70' : '';
    }
  }

  // 로그인 계정 사용 ------------------------------------------------------------------------------------------------------------------------------
  // input으로 받을 실계정
  const accountId = ref('');
  // 웹에서 아이콘으로 보여줄 값
  const accountChar = computed(()=>{//계정 앞글자
    return accountId.value?.charAt(0).toUpperCase() || 'G';
  })
  const mediaName = ref('');
  const mediaSeq = ref('');
  const logoUrl = ref('');
  const getDate = () => { return datepicker.value.format('yyyyMMdd'); };
  const mediaCode = ref(''); // 매체번호 (번호: ****)
  const ROOT_SERIAL = computed(() => { return `${getDate()}${mediaCode.value}`; });

  // 알람 관련 기능 ---------------------------------------------------------------------------------------------------------------------------
  // const alertForScrapInfo = ref({});// alert에 대한 정보
  // function changeAlertInfo(obj){
  //   alertForScrapInfo.value = {};
  //   alertForScrapInfo.value = obj;
  // }

  // const alertFT = {// alert마다 v-snackbar의 v-model 값
  //   scrap : {
  //     add: ref(false),              // 북마크(북마크) 생성 시 알림창
  //     count: ref(false),            // 북마크(북마크) 생성 시 갯수 제한 걸릴 때 알림창
  //     delete: ref(false),           // 북마크(북마크) 삭제 시 알림창
  //   },
  //   email : {
  //     add : ref(false),             // 메일전송(주소록) 생성 시 알림창
  //     delete : ref(false),          // 메일전송(주소록) 삭제 시 알림창
  //   },
  //   other : {
  //     print: ref(false),            // 인쇄시 시 알림창
  //     imgDownload: ref(false),      // 이미지 다운로드 시 알림창
  //     shareSNS: ref(false),         // sns 공유 시 알림창
  //   }
  // }
  // function changeAlertFT(where, act){
  //   alertFT.where.act.value = true;
  // }

  function printAlertToTrue() {// emit from articleDetailView.vue
    const article = articleDetailViewData.value;
    userAlertStore.alertForScrapInfo = Object.assign({}, article);
    userAlertStore.alertForScrapInfo.status = 'printed';

    userAlertStore.alertFT.other.print = true;
  }

  function imgDownloadAlertToTrue(name, isIOS=false) {
    userAlertStore.alertForScrapInfo = {
      Title: name == '' ? '' : name,
      status: isIOS ? 'rejected' : 'imgDownloaded',
      // status: 'rejected',//테스트용
    }
    userAlertStore.alertFT.other.imgDownload = true;
  }
  function shareSNSAlertToTrue() {// url 복사만 한 경우
    const article = articleDetailViewData.value;
    userAlertStore.alertForScrapInfo = Object.assign({}, article);
    userAlertStore.alertForScrapInfo.status = 'urlCopied';

    userAlertStore.alertFT.other.shareSNS = true;
  }

  // limitationg 값에 따라 상단 헤더의 tts 실행 버튼 비활성화 여부 확인 -----------------------------------------------------------------------------------
  const isTtsAvailableByLimitation = computed(() => {
    if(selectedScrapSeq.value != -1){ // 북마크 선택상태라면 항상 tts 가능 하도록!
      return true;                    // 자른 지면 북마크의 경우 handListClick()에서 변경되는 isCuttingScrap 값이 true인 경우 비활성화 됨.
    }
    const idx = _pageSideToArray.value[selectedPageIndex.value]?.[0]?.idx || 0;
    const limit = userStore.limitation || 100;
    return idx < limit;
  });
  // limitationg 값에 따라 상단 헤더의 지면 자르기 버튼 비활성화 여부 확인.
  const isCuttingAvailableByLimitation = computed(() => {
    const idx = _pageSideToArray.value[selectedPageIndex.value]?.[0]?.idx || 0; // 지면 자르기 버튼은 단면보기에서만 가능하므로 [0] 적용함.
    const limit = userStore.limitation || 100;
    return idx < limit;
  });
  // --------------------------------------------------------------------------------------------------------------------------------------------------

  // 지면 자르기 -> 북마크 생성 기능 구현 ----------------------------------------------------------------------------------------------------------------

  const selectedTool = ref('alongLine');

  const isCuttingOverlayOn = ref(false);
  const isCuttingMobileOverlayOn = ref(false);
  const presentCuttingPageSerial = ref('');
  let presentCuttingPageUrl = '';
  // 선오리기/면오리기 모달창 띄우기
  async function setCuttingCanvas(){

    if(!isCuttingAvailableByLimitation.value){
      if(mobile.value) {
        isCuttingMobileOverlayOn.value = false;
      } else {
        isCuttingOverlayOn.value = false;
      }
      isAccessDeniedOverlayOn.value=true;  // 읽기 권한 없는 페이지라고 알리기
      return;
    }

    // v-dialog의 v-bind 값에 의해 isCuttingOverlayOn.value 또는 isCuttingMobileOverlayOn.value는 자동으로 true 로 변경됨.

    // 내부 해상도 조절
    const canvas = document.getElementById("c");

    // 현재 지면 정보 설정 : 현재 limitation 안에 해당하는 지면인지 확인 후 현재 지면serial(presentCuttingPageSerial.value), url(presentCuttingPageUrl) 세팅.
    setForSidePageTwo(true);
    userJS.cutting_canvas_serial.value = presentCuttingPageSerial.value;

    // 이미지 먼저 로드해서 비율을 계산하고, 캔버스 크기 동적 설정
    // /paperDown URL을 axios로(blob) 받아 ObjectURL로 로드 -> axios.interceptor.request에 의해 header에 pmaster-sid를 포함시키기 위함.
    const rawUrl = location.origin + presentCuttingPageUrl; // 기존과 동일한 실제 요청 URL
    await axios.get(rawUrl, {
      responseType: 'blob',
      withCredentials: true,          // 인터셉터 + 쿠키 필요 시
    }).then(({ data: blob }) => {
      const objectUrl = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => {
        const originalWidth = img.width;
        const originalHeight = img.height;

        const canvasWidth = !mobile.value ? vw.value * 55 : vw.value * 91;
        const ratio = originalHeight / originalWidth;
        const canvasHeight = canvasWidth * ratio;

        // 캔버스 크기 적용
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        // fabric.Canvas 초기화
        userJS.cutting_canvas1.value = new fabric.Canvas('c');

        // 이미지 추가
        userJS.addImageToCanvas(objectUrl);

        // 콜백 설정
        userJS.setCallback_addScrap(function (param1, param2, param3, param4) {
          addScrapAPI(param1, param2, param3, param4);// userJS에서 실행할 addScrapAPI()에 필요한 파라미터를 같이 넘김.
        });

        // 기본 도구 선택 : 처음 모달창 띄울 땐 '선오리기'가  default.
        setCuttingCanvas_alongLine(true);
        // ObjectURL 정리 시점은 addImageToCanvas 내부 로딩 완료 후 적절히 호출하는 편이 안전
        try { URL.revokeObjectURL(objectUrl); } catch (e) {}
      };
      // 실제 로드 시작
      img.src = objectUrl;
    }).catch((e) => {
      console.error('cutting image load failed:', e);
    });
  };
  // 선오리기
  async function setCuttingCanvas_alongLine(isFirstOpen=false){
    userJS.cuttingCanvas_resetBtnfunc(isFirstOpen); // 새로고침 버튼 기능 : 직전에 생성중인 상태와 직전에 생성했었던 도형 지우고 이전에 저장된 도형 기록들 불러오기

    const canvas = userJS.cutting_canvas1.value;
    // 기존 이벤트 제거
    canvas.off('mouse:down');
    canvas.off('mouse:move');
    canvas.off('mouse:up');

    canvas.on('mouse:down', userJS.cuttingCanvas_handleMouseDown_alongLine);
    canvas.on('mouse:move', userJS.cuttingCanvas_handleMouseMove_alongLine);

    selectedTool.value = 'alongLine';
  };
  // 면오리기
  async function setCuttingCanvas_alongArea(){
    userJS.cuttingCanvas_resetBtnfunc(); // 새로고침 버튼 기능 : 직전에 생성중인 상태와 직전에 생성했었던 도형 지우고 이전에 저장된 도형 기록들 불러오기

    const canvas = userJS.cutting_canvas1.value;
    // 기존 이벤트 제거
    canvas.off('mouse:down');
    canvas.off('mouse:move');
    canvas.off('mouse:up');

    canvas.on('mouse:down', userJS.cuttingCanvas_handleMouseDown_alongArea);
    canvas.on('mouse:move', userJS.cuttingCanvas_handleMouseMove_alongArea);
    canvas.on('mouse:up', userJS.cuttingCanvas_handleMouseUp_alongArea);

    selectedTool.value = 'alongArea';
  };
  // cutting 스크랩 이미지 저장 취소하기
  function cuttingCanvas_unsaveScrap(){

    userJS.cuttingCanvas_unsaveBtnfunc();

    // 새로운 도형 그릴 수 있는 상태로 갱신
    userJS.resetCuttingFunc();
    // 저장 여부 묻는 모달창 닫기
    userJS.isCuttingPageSavingOverlayOn.value = false;
  }
  // cutting 스크랩 이미지 저장하기
  function cuttingCanvas_saveScrap(){

    if(!userJS.cutting_canvas_title.value){
      alert('북마크 제목을 입력해주세요.');
      return;
    }

    // addScrapAPI() 함수 실행하기 전에 좌표값 포함한 파라미터 생성하는 기능.
    userJS.cuttingCanvas_call_addScrapAPI();

    // 새로운 도형 그릴 수 있는 상태로 갱신
    userJS.resetCuttingFunc();
    // 저장 여부 묻는 모달창 닫기
    userJS.isCuttingPageSavingOverlayOn.value = false;
  }

  // --------------------------------------------------------------------------------------------------------------------------------------------------

  // 북마크(북마크) 기능 구현 ---------------------------------------------------------------------------------------------------------------------------
  // 북마크 목록 API 호출 함수 ------------------------------------------------------------------
  const scrapData = ref([]);

  async function scrapListAPI (){
    let params = new URLSearchParams();
    params.append('mediaSeq', mediaSeq.value);
    return await userJS._api.getScrapList(params);
  };

  const scrapSerialList = ref([]);
  async function showScrapList(){
    const res = await scrapListAPI();
    try {
      if(res){
        const tmp = new Set();  // Set을 사용하여 중복 제거. 잘린 이미지 스크랩인 경우 한 지면(지면 serial)에 여러개가 생성될 수 있기 때문임.
        scrapData.value = res.scrapGroup;
        scrapData.value.forEach(g => {
          g.list && g.list.forEach(item => {

            // item.imgType == 2 ->
            // 잘린 이미지 스크랩인 경우 한 지면(지면 serial)에 여러개가 생성될 수 있기 때문에
            // 이 경우 serial가 아닌 scrapSeq가 있는지 여부를 판단하기 위함.
            tmp.add(item.imgType == 2 ? item.scrapSeq : item.serial);

          });
        });
        userEmailStore.localScrapData = scrapData.value; // NestedDrawer.vue, MailSide.vue에서 scrapData.value를 직접 사용하기 위함.

        scrapSerialList.value = [...tmp];  // Set을 다시 배열로 변환
        sortScrapList(scrapAlignment.value);// 북마크일 내림차순
      }
    } catch (error) {
      throw error;
    }
  }

  // 선택된 북마크 그룹,
  const selectedScrapGroupSeq = ref(-1);
  function setSelectedScrapGroupSeq(seq){
    selectedScrapGroupSeq.value = seq;
  }

  const scrapAlignment = ref('scrapDate');// 북마크 정렬 방식 선택
  function sortScrapList(condition) {
    const scrapList = scrapData.value;
    if(!scrapList)
      return;
    scrapAlignment.value = condition;// 북마크 목록 전환
    scrapList.forEach(group => {
      if(!group.list) return;
      group.list.sort((a, b) => new Date(b.regDate) - new Date(a.regDate));
      if (condition == "publicationDate")
        group.list.sort((a, b) => new Date(b.newsDate) - new Date(a.newsDate));
    });
  }

  // 북마크 생성 API 호출 함수 -------------------------------------------------------------------
  let isInBookmarkAddProgress = false; // 요청 진행 중 여부를 확인하는 플래그
  async function addScrapAPI (serial, title=null, fromNoArticleDetailView=false, coordinate=null) {// fromNoArticleDetailView == true -> 중앙의 지면 이미지 or 선오리기/면오리기 자른 스크랩 이미지를 북마크로 생성할 때.

    // 기존 켜져있던 모든 alert창 끄기
    userAlertStore.$resetAllAlert();

    if (isInBookmarkAddProgress) return;
    isInBookmarkAddProgress = true;// 요청 진행 중

    try {
      let params = new FormData();
      params.append('serial', serial);
      params.append('newsDate', serial.substring(0, 8));// 북마크 생성 날짜(현재 날짜) ex) 20240531
      params.append('title', title);

      if(coordinate) { // 선오리기/면오리기 자른 스크랩 이미지 저장 시
        params.append('imgType', 2);// 지면(쪽):0, 기사:1, 자르기:2
        params.append('coordinate', encodeURIComponent(coordinate));
      } else {
        params.append('imgType', 1);// 지면(쪽):0, 기사:1, 자르기:2
      }
      params.append('groupSeq', selectedScrapGroupSeq.value);//selectedScrapGroupSeq : 북마크 리스트에서 클릭하여 변경(emit)하는 그룹 시퀀스.
      params.append('mediaSeq', mediaSeq.value);

      let res;
      if (fromNoArticleDetailView) {// 중앙 -지면 이미지에서 생성 요청 여부.

        let newsDate = '';// 해당 기사 발행일 담는 변수.
        let iscuttingCanvasData = false;
        if(coordinate){ // 선오리기/면오리기 자른 스크랩 이미지 저장 시
          newsDate = `${serial.substring(0, 4)}-${serial.substring(4, 6)}-${serial.substring(6, 8)}`;
          iscuttingCanvasData = true;
        } else {
          for (const page of newsImages.value) {
            page.Articles.forEach(a => {
              if(a.Serial == serial){
                newsDate = `${a.Serial.substring(0, 4)}-${a.Serial.substring(4, 6)}-${a.Serial.substring(6, 8)}`;
                title = a.Title;
                params.set('title', title);
              }
            })
          }
        }

        // 북마크 갯수 제한할 때
        let scrapCount = userStore.$isOption(roleSelection.value, 'scrapCount');
        if(scrapCount && (Number(scrapCount) <= scrapSerialList.value.length) ){
          if(iscuttingCanvasData) {
            userJS.cuttingCanvas_unsaveBtnfunc();
          }
          userAlertStore.alertForScrapInfo.status = 'limited';
          userAlertStore.alertFT.scrap.count = true;
          return;
        }

        res = await userJS._api.postAddScrap(params);
        if (res.success) {
          userAlertStore.alertForScrapInfo = {
            PageName: `${serial.substring(12, 15)}면`,
            Title: title,
            Date: newsDate,
            ScrapDate: new Date().format('yyyy-MM-dd'),
            status: 'added',
          };
          await showScrapList(); // 생성 후 북마크 리스트 갱신
          userAlertStore.alertFT.scrap.add = true; // 알람창(AllSnackbars.vue) 띄우기.
        }
      } else {// 기사 상세보기 창에서 생성 요청
        res = await userJS._api.postAddScrap(params);
      }
      return res;
    } catch (error) {
      throw error;
    } finally {
      // 플래그를 리셋
      isInBookmarkAddProgress = false;
    }
  };

  // 북마크 삭제 API 호출 함수 -------------------------------------------------------------------
  let isInBookmarkDeleteProgress = false; // 요청 진행 중 여부를 확인하는 플래그
  async function removeScrapAPI (scrapInfo) {

    if (isInBookmarkDeleteProgress) return;
    isInBookmarkDeleteProgress = true;// 요청 진행 중

    // 자른 지면 북마크는 한 번 삭제하면 다시 똑같은 북마크 정보를 만들 수 없으므로 한 번 더 확인함
    if(scrapInfo.imgType == 2 && !confirm('자른 지면 북마크를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.')){
      isInBookmarkDeleteProgress = false;
      return;
    }

    try {
      let params = new URLSearchParams();
      params.append('serial', scrapInfo.serial);
      params.append('mediaSeq', mediaSeq.value);
      params.append('scrapSeq', scrapInfo.scrapSeq);
      params.append('imgType', scrapInfo.imgType);

      const res = await userJS._api.deleteRemoveScrap(params);// 알림창 띄우기 및 스크랩 리스트 갱신은 toggleScrap()에서 실행됨.
      if(res){
        // 잘린 스크랩은 삭제되는 경우 해당 상세보기 창이 바로 닫혀야 함.
        if(scrapInfo.imgType == 2 && articleDetailViewData.value.Serial == scrapInfo.serial && drawer5.value) {
          drawer5.value = false;
        }

        userAlertStore.alertForScrapInfo = {
          PageName: `${scrapInfo.serial.substring(12, 15)}면`,
          Title: scrapInfo.title,
          Date: scrapInfo.newsDate,
          ScrapDate: scrapInfo.regDate.substring(0, 10),
        };
        userAlertStore.alertForScrapInfo.status = 'deleted';
        userAlertStore.alertFT.scrap.delete = true;
        await showScrapList();
      }

      return res;
    } catch (error) {
        console.error('Error removing scrap:', error);
        throw error; // 오류를 호출자에게 전달
    } finally {
        // 플래그를 리셋
        isInBookmarkDeleteProgress = false;
    }
  };

  const toggleScrapActive = ref(true);// 북마크버튼 활성/비활성
  async function toggleScrap(serial, seq){// '북마크' 버튼 - 북마크 생성, 삭제 기능
    toggleScrapActive.value = false; // 사용자가 연속해서 누를 때 - disabled 처리 이용한 에러 방지

    // 기존 켜져있던 모든 alert창 끄기
    userAlertStore.$resetAllAlert();

    let article = null;
    try {

      if(scrapSerialList.value.includes(seq || serial)){// 이미 북마크 되어 있다면 기존 북마크 삭제!

        scrapData.value.forEach(g => {
          g.list && g.list.forEach(scrap => {
            if (article) return; // 이미 article을 찾았다면 더 이상 반복하지 않음
            if(seq && scrap.scrapSeq == seq){
              article = scrap;
            }
            if(serial && scrap.serial == serial){
              article = scrap;
            }
          });
        });

        await removeScrapAPI(article);

      } else {// 북마크 되어있지 않다면 북마크 생성!
        // cutting 스크랩에 대한 상세보기에서는 북마크되어 있지 않는 경우 해당 상세보기 창도 꺼지므로 여기까지 고려하지 않아도 됨.

        userAlertStore.alertForScrapInfo = Object.assign({}, articleDetailViewData.value);// detailview에서 사용되는 기사 복사

        article = Object.assign({}, articleDetailViewData.value);

        let scrapCount = userStore.$isOption(roleSelection.value, 'scrapCount');
        // 북마크 갯수 제한할 때
        if(scrapCount && (Number(scrapCount) <= scrapSerialList.value.length) ){
          userAlertStore.alertForScrapInfo.status = 'limited';
          userAlertStore.alertFT.scrap.count = true;
          toggleScrapActive.value = true;
          return;
        }
        const res = await addScrapAPI(serial, article.Title);
        if(res){
          userAlertStore.alertForScrapInfo = {
            PageName: `${serial.substring(12, 15)}면`,
            Title: article.Title,
            Date: `${serial.substring(0, 4)}-${serial.substring(4, 6)}-${serial.substring(6, 8)}`,
            ScrapDate: new Date().format('yyyy-MM-dd'),
            status: 'added',
          };
          userAlertStore.alertFT.scrap.add = true;
          await showScrapList();
        }
      }
    } catch (error) {
      throw error;
    }
    toggleScrapActive.value = true;
  }
  // --------------------------------------------------------------------------------------------------------------------------------------------------


  // --------------------------------------------------------------------------------------------------------------------------------------------------

  // 온라인 기사 형식 변경 함수.
  function changeOnlineContentForm(content) {
    // 이미지만 가운데 정렬.
    content = content.replaceAll('<img', '<img style="display: block; margin: 0 auto; max-width: 100%; height: auto;"')
    return content;
  }

  // API -> 기사 상세보기 데이터
  // 기사 목록 클릭 시 or 지면에서 해당 기사 클릭 시 함수 활성화
  async function showArticleDetailView(serial, scrapInfo=undefined){// scrapInfo !== undefined -> 북마크 리스트 -> handleListClick()에서 진입 시
    try {
      let params = new URLSearchParams();
      params.append('serial', serial);
      params.append('mediaSeq', mediaSeq.value);

      if(scrapInfo && scrapInfo.imgType == 2) {
        scrapData.value.forEach((g)=>{
          if(g.list){
            g.list.forEach((scrap)=>{
              if(scrap.scrapSeq == scrapInfo.scrapSeq){
                scrap.PageName = `${scrap.serial.substring(12, 15)}면`;
                const renameObj = Object.keys(scrap).reduce((acc, key)=>{// ArticleDetailView.vue에서 사용되는 키이름 변경
                  const newKey = key == "title" ? "Title"
                               : key == "newsDate" ? "Date"
                               : key == "serial" ? "Serial"
                               : key;
                  acc[newKey] = scrap[key];
                  return acc;
                }, {})
                articleDetailViewData.value = renameObj;
              }
            })
          }
        })
      } else {
        if(keywordFromSearchResults.value.length && userStore.$isOption(roleSelection.value, 'hilight'))
          params.append('keyword', keywordFromSearchResults.value.join(' ')); // join() : 배열로 검색어를 보낼 떄 api측에서 단어 사이의 쉼표(,)를 빈 문자열로 대체해서 받을 수 있도록 하기 위함.
        const res = await userJS._api.paperInfo.withContent(params);
        if (res) {
          let obj = res.ArticleList.Article;
          obj.Date = obj.update.split(' ')[0];
          obj.Content = obj.Content;
          if(obj.onlineContent) obj.onlineContent = changeOnlineContentForm(obj.onlineContent);
          articleDetailViewData.value = obj;
        }
      }
    } catch (error) {
      throw error;
    }
  }
  // tab키 비활성화, PgUp/PgDown키 활성화------------------------------------------------------------------------------------------------------------------
  function handleKey(){
    window.addEventListener('keydown', function(event) {
      if (event.key === "Tab") {
        event.preventDefault();
      }

      // 지면 이동 단축키 기능
      if (event.key === 'PageUp') {
        setupFunc.preNext(1);
      } else if (event.key === 'PageDown') {
        setupFunc.preNext();
      }

      // 기사 이동 및 (지면 내 첫번째 기사 또는 마지막 기사일 때) 지면 이동 단축키 이동
      if(!drawer5.value || userJS.isSearchFocused.value || userEmailStore.isSearchFocused) return; // 기사 상세보기가 켜져있을 때만, 기사 찾기 검색창에 포커스 되어있지 않을 때에만 해당 키보드 기능이 가능하도록.
      if (event.key === 'ArrowLeft') {
        previousArticlePageForArrowKey();
      } else if (event.key === 'ArrowRight') {
        nextArticlePageForArrowKey();
      }
    });
  }

  // 방향키에 의한 기사 이동 시 tts 대상도 이동하는 기능
  let keySuccessWithTts = true; // changeInfoByTts() 작업 완료 시 true로 변경
  function changeWithTts(){
    if(isTtsPlaying.value) {// tts 실행 중
      isntEnd(true);
    } else {
      isntEnd();
      changeInfoByTts(true);
      keySuccessWithTts = true;
    }
  }

  // '←' 클릭 시 이전 기사, 이전 페이지 이동 기능
  async function previousArticlePageForArrowKey() {// emit from PaperCenter.vue

    if(!keySuccessWithTts) return;
    keySuccessWithTts = false;

    let serial = selectedArticleSerial.value
    if (serial == '' || serial != articleDetailViewData.value.Serial) return;// 기사 상세보기 창 내 기사 이미지와 함께 변동되도록.
    const currSerial = serial;

    let groupIdx = -1;//현재 보이는 지면의 페이지 index
    let pageIdx = -1;//현재 보이는 지면의 방향: 0(좌측) or 1(우측)
    let artIdx = -1;//현재 지면 안에서 선택된 기사의 순서

    let articles = {};//현재 지면 - 기사들 정보
    let news = _pageSideToArray.value;
    outer:
    for(let gIdx in news){
      let group = news[gIdx];
      for (let pIdx in group){
        let g = group[pIdx];
        for(let aIdx in g.Articles){
          let a = g.Articles[aIdx];
          if(a.Serial != currSerial) continue;
            groupIdx = Number(gIdx);
            pageIdx = Number(pIdx);
            artIdx = Number(aIdx);
            articles = g.Articles;
            break outer;
        }
      }
    }

    // let prevIdx = artIdx == 0 ? artIdx : artIdx-1;
    let prevIdx = artIdx-1;
    let prevSerial = '';
    function goPrevPage(){//이전 페이지 이동
      if(groupIdx == selectedPageIndex.value){//현재 화면에 띄운 지면일 때만 이동.
        selectedPageIndex.value = groupIdx-1;
        selectedArticleGroupSerial.value = _pageSideToArray.value[selectedPageIndex.value][0].Serial;
      }
    }
    async function goPrevArt(groupIdx, num){//이전 지면 이동
      // if(userStore.limitation && (groupIdx && groupIdx > userStore.limitation-1))  // limitation 값 이후는 상세보기 창 열람 권한 없음.
      // {// 북마크 클릭 시 - limitation과 상관없이 기사 상세보기 창 볼 수 있도록.
      //   drawer5.value = false;
      //   isAccessDeniedOverlayOn.value = true;
      //   return;
      // }

      let pageInfo = news[groupIdx][num];
      let articles = pageInfo.Articles;
      selectedArticleSerial.value = articles[articles.length-1].Serial;
      if(drawer5.value) await showArticleDetailView(selectedArticleSerial.value); // 기사 상세보기 창이 켜져 있을 때에만.
      changeWithTts();
    }

    if(prevIdx < 0){//현재 지면의 첫번째 기사라면-
      if(groupIdx == 0){//첫번째 지면이라면 더이상 이동하지 않음.
        return;
      } else {
        // 이제 이전 페이지의 마지막 기사로 넘어가자!
        // 1) 단면일 때
        if(pageSide.value == 1){
            goPrevPage();
            goPrevArt(groupIdx-1, 0);
        // 2) 양면일 때
        } else {
          //좌측 지면 다 읽으면
          if(pageIdx == 0){
            let choosePrevPageIdx =
              news[groupIdx-1][0].firstpage
              || news[groupIdx-1][0].lastpage
              || news[groupIdx-1][0].doublepage
              || news[groupIdx-1][0].localpage
              || news[groupIdx-1][0].isNextLocalpage ? 0 : 1;
              goPrevPage();
              goPrevArt(groupIdx-1, choosePrevPageIdx);
          //우측 지면 다 읽으면
          } else {
            goPrevArt(groupIdx, pageIdx-1);
          }
        }
      }
    } else {//현재 지면의 첫번째 기사가 아니라면-
      prevSerial = articles[prevIdx].Serial;
      selectedArticleSerial.value = prevSerial;//selectedArticleSerial.value -> watch로 감시 중.
      await showArticleDetailView(selectedArticleSerial.value); // 기사 상세보기 창이 켜져 있을 때에만.
      changeWithTts();
    }
  }

  // → 클릭 시 이전 기사, 이전 페이지 이동 기능
  async function nextArticlePageForArrowKey() {// emit from PaperCenter.vue

    if(!keySuccessWithTts) return;
    keySuccessWithTts = false;

    let serial = selectedArticleSerial.value
    if (serial == '' || serial != articleDetailViewData.value.Serial) return;
    const currSerial = serial;

    let groupIdx = -1;//현재 보이는 지면의 페이지 index
    let pageIdx = -1;//현재 보이는 지면의 방향: 0(좌측) or 1(우측)
    let artIdx = -1;//현재 지면 안에서 선택된 기사의 순서

    let articles = {};//현재 지면 - 기사들 정보
    let pageLength = 0;//현재 지면의 기사 개수
    let news = _pageSideToArray.value;
    outer:
    for(let gIdx in news){
      let group = news[gIdx];
      for (let pIdx in group){
        let g = group[pIdx];
        for(let aIdx in g.Articles){
          let a = g.Articles[aIdx];
          if(a.Serial != currSerial) continue;
            groupIdx = Number(gIdx);
            pageIdx = Number(pIdx);
            artIdx = Number(aIdx);
            articles = g.Articles;
            pageLength = articles.length;
            break outer;
        }
      }
    }

    let nextIdx = artIdx+1;
    let nextSerial = '';
    function goNextPage(){//다음 페이지 이동
      if(groupIdx == selectedPageIndex.value){//현재 화면에 띄운 지면일 때만 이동.
        selectedPageIndex.value = groupIdx+1;
        selectedArticleGroupSerial.value = _pageSideToArray.value[selectedPageIndex.value][0].Serial;
      }
    }
    async function goNextArt(groupIdx, num){//다음 지면 이동

      let pageInfo = news[groupIdx][num];
      let idx = pageInfo.idx || 0;
      let limit = userStore.limitation || 100;
      if( idx >= limit ) {
        isntEnd();
        cancelArticleSelect();
        presentTtsSerial = '';
        articleDetailViewData.value = {};
        isAccessDeniedOverlayOn.value = true;
        drawer5.value = false;
        changeInfoByTts();
        return;
      }

      selectedArticleSerial.value = pageInfo.Articles[0].Serial;//selectedArticleSerial.value -> watch로 감시 중.
      await showArticleDetailView(selectedArticleSerial.value);
      changeWithTts();
    }

    if(nextIdx > (pageLength-1)){//현재 지면의 마지막 기사를 다 읽었다면-
      if(groupIdx == news.length-1){//마지막 지면이라면 더이상 이동하지 않음.
        return;
      } else {
        // 이제 다음 페이지의 기사로 넘어가자!
        // 단면일 때
        if(pageSide.value == 1){
          goNextPage();
          goNextArt(groupIdx+1, 0);
        // 양면일 때
        } else {
          //좌측 지면 다 읽으면
          if(pageIdx == 0){
            if(news[groupIdx].length != 2) {// 통판 지면인 경우
              goNextPage();
              goNextArt(groupIdx+1, 0);
            } else {
              goNextArt(groupIdx, pageIdx+1);
            }
          //우측 지면 다 읽으면
          } else {
            goNextPage();
            goNextArt(groupIdx+1, 0);
          }
        }
      }
    } else {//현재 지면의 마지막 기사가 아니라면-
      nextSerial = articles[nextIdx].Serial;
      selectedArticleSerial.value = nextSerial;//selectedArticleSerial.value -> watch로 감시 중.
      await showArticleDetailView(selectedArticleSerial.value);
      changeWithTts();
    }
  }

  // ---------------------------------------------------------------------------------------------------------------------------------------------------
    // 테마 변경 기능 ==========================================[start]==========================================
  const theme = useTheme();
  const currentTheme = ref(theme.global.name);

  // 테마 변경 함수
  function toggleTheme () {// plugins/vuetify.js에서 테마 생성 및 설정 가능
    theme.global.name.value = theme.global.name.value == "lightTheme" ? "darkTheme" : "lightTheme";
  }

  // 사용자 모바일 레이아웃 세팅 : leftSidebar.themeToggle.firstView 값에 따라 초기 테마 결정
  // → mobile.value 감시자에서 호출
  function applyInitialThemeFromMobileUI() {
    // 현재 화면이 모바일인지 여부
    const isMobileNow = mobile.value;

    // 모바일/PC 여부에 따라 layout 가져오기
    // - isMobileNow == true  이면: 모바일용 customUI 또는 initialCustomUiVO
    // - isMobileNow == false 이면: initialCustomUiVO
    const themeToggleCfg = userMobileStore.$getMobileLayout(
      isMobileNow,
      'leftSidebar',
      'themeToggle'
    );

    // 설정이 아예 없으면 건드리지 않음
    if (!themeToggleCfg) return;

    const firstView = themeToggleCfg.firstView;

    // showYn은 완전히 무시하고, firstView만 기준으로 초기 테마 세팅
    if (firstView === 'DARK_MODE') {
      theme.global.name.value = 'darkTheme';
    } else if (firstView === 'LIGHT_MODE') {
      theme.global.name.value = 'lightTheme';
    }
  }

  // ========================================================[end]============================================

  const mainDrawer = ref(true);      // 좌측 - 1depth
  const nestedDrawer = ref(false);    // 좌측 - 2depth
  const sidebarTabs = computed(() => userMobileStore.leftSidebar.$tabs());
  const tab = ref('');

  // 좌측 NestedDrawer.vue 컴포넌트가 깨져서 일부분만 화면에 보이는 문제 해결 ========
  watch(mainDrawer, (newVal)=>{
    if(!newVal) document.querySelector('#nestedDrawer').style.display = 'none';
    //여기서 dispaly = '' 처리하면 MainDrawer.vue가 true가 되면서 다 펼쳐지기도 전에 NestedDrawer.vue 컴포넌트의 일부분이 먼저 보이게 됨!
    //-> 바로 아래에서 처리 완료.
  })
  watch(nestedDrawer, (newVal)=>{
    if(newVal) document.querySelector('#nestedDrawer').style.display = '';
  })
  // 열린 상태의 nestedDrawer 표시 여부를 리사이즈(mobile.value: false → true) 시 점검하는 헬퍼
  function handleMobileNestedDrawerOnResize (isMobile) {
    // nested drawer가 열려 있고, 현재 모바일일 때만 체크
    if (!nestedDrawer.value) return;

    const presentTab = tab.value || '';            // 예: 'option-3'
    const tabIndex = Number(presentTab.slice(-1)); // '3' → 3
    if (Number.isNaN(tabIndex)) return;

    const key = userMobileStore.leftSidebar.$tabs()[tabIndex - 1]?.key; // 현재 탭에 해당하는 key 가져오기

    // key가 존재하고, 해당 탭을 숨겨야 하는 상태라면 drawer / tab 초기화
    if (key && !userMobileStore.$isUiVisible(isMobile, 'leftSidebar', key)) {
      nestedDrawer.value = false;
      tab.value = ''; // 탭 선택 상태 모두 닫기
    }
  };
  // Vuetify의 mobile 값이 바뀔 때마다 store에 한번만 반영
  watch(
    () => mobile.value,
    (newValue, oldValue) => {
      loadStyle();
      userMobileStore.setIsMobile(newValue);
      if(oldValue === false && newValue) handleMobileNestedDrawerOnResize(newValue);
      if(newValue && !userMobileStore.uiVisible.leftSidebar.sidebarInitialExpanded) {
        mainDrawer.value = false;
      }
      applyInitialThemeFromMobileUI();
    },
    { immediate: true }
  );
  // =============================================================================

  const drawer5 = ref(false);         // 우측 - 기사 상세보기
  function drawerControl() {
    mainDrawer.value = !mainDrawer.value;
    nestedDrawer.value = false;
    if(!mainDrawer.value) tab.value = '';// sidebar 1depth가 닫히면 tap 선택상태 모두 닫히기

    if(mobile.value && drawer5.value) {
      mainDrawer.value = true;
      drawer5.value = false;
    }
  }
  function nestedDrawerToFalse() {
    nestedDrawer.value = false;
    tab.value='';
  }
  function changeDrawer5(val) { drawer5.value = val; }

  const vh = ref(0);
  const vw = ref(0);
  function updateVh() {
    vh.value = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh.value}px`);

    vw.value = window.innerWidth * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw.value}px`);
  };

  let resizeObserver;
  const catchCenterWidth = () => {
    const paperCenter = document.querySelector('#paperCenter');

    resizeObserver = new ResizeObserver(() => {// `ResizeObserver` 설정
      let {width: aw} = document.getElementById("articleDetailView").getBoundingClientRect();
      let {left: bl, width: bw} = document.getElementById("nestedDrawer").getBoundingClientRect();
      if(aw+bl+bw+100 >= width.value) {
        userJS.isDrawerOverlap.value = true;// 좌측 메뉴와 우측 기사 상세보기 창이 만났을 때 true
      } else {
        userJS.isDrawerOverlap.value = false;
      }
    });
    resizeObserver.observe(paperCenter);// paperCenter 엘리먼트의 크기 변화를 감지
  };
  function handleResize () {
    loadStyle();
    updateVh();
    moreFuncYn.value = false; // 상단 헤더 더보기 메뉴 닫기
  };

  watch(()=>userStore.searchHiColor, ()=>{// 키워드 하이라이트 색상 변경 버튼( #colorPickerBtn ) 아이콘 색상을 css에서 바꾸기 위함.
    document.documentElement.style.setProperty('--hilight-color', userStore.searchHiColor);
  })

  const widthWatching = () => {
    document.documentElement.style.setProperty('--app-width', width.value);

    let nestedWidth = document.getElementById('nestedDrawer').offsetWidth;
    document.documentElement.style.setProperty('--nestedDrawer-width', nestedWidth);
  }

  // 현재날짜 변경될때마다 해당 날짜 지면 불러오기
  watch(datepicker, (newValue) => {
    if (!newValue) {
      selectedYear.value = null;
      selectedMonth.value = null;
      selectedDay.value = null;
      return;
    }

    // 선택일 UI는 항상 갱신
    selectedYear.value = Number(newValue.format('yyyy'));
    selectedMonth.value = Number(newValue.format('MM'));
    selectedDay.value = Number(newValue.format('dd'));
    lastValidYear.value = selectedYear.value;
    lastValidMonth.value = selectedMonth.value;
    lastValidDay.value = selectedDay.value;

    // 매체 변경 중이면 getPublicationDate는 changeRoleSelection에서 직접 호출하므로 스킵
    if (isPageLoading.value
        || isSyncingRoleDatepicker
        || pageLoadingType.value === 'media') { // 매체 변경 시 datepicker 초기화로 인한 불필요한 getPublicationDate 호출 방지
      isSyncingRoleDatepicker = false;
      return;
    }

    getPublicationDate(newValue);
    syncDateSelectBoxesFromDate(newValue);
  });

  // ---------------------------------------------------------------------------------------------------------------------------------------------------
  onMounted(async () => {
    await getLoginInfo();

    catchCenterWidth();
    handleKey();// 특정 키 기능 설정.
    handleResize();// 브라우저 크기에 따라 반응형으로 컴포넌트의 높이를 조절하기 위해 새로운 css 변수를 생성.

    //getPublicationDate(datepicker.value);
    // 20250918 최지현 - datepicker.value를 별지 날짜로 변경시켜 watch에 의해 별지 날짜 지면으로 바로 이동하도록.
    if(userStore.localpageSerial == ''){
      getPublicationDate(datepicker.value);
    } else {
      const localpageDate = userStore.localpageSerial.substring(0, 8);
      const localpageIdx = Number(userStore.localpageSerial.slice(-3))

      if(!isNaN(localpageIdx) && localpageIdx == 1){ // 별지이동시 1면을 불러오려고 하면, 그냥 바로 지면 데이터 띄우도록.
          userStore.localpageSerial = '';
        if (userStore.$isValidYyyyMMddByNewDate(localpageDate)){
          datepicker.value = new Date(`${localpageDate.substring(0, 4)}-${localpageDate.substring(4, 6)}-${localpageDate.substring(6, 8)}`);
          syncDateSelectBoxesFromDate(datepicker.value);
          return;
        } else {
          alert("특정 지면 바로가기 링크의 지면 날짜가 정확하지 않습니다. \n현재 날짜 지면을 불러옵니다. \n확인 후 다시 시도해 주시기 바랍니다. ");
          userStore.localpageSerial = '';
          getPublicationDate(datepicker.value);
        }
      }

      // 날짜정보가 날짜 형식이 아닐 때.
      // 추후 HeaderPage.vue의 getPublicationDate()에서 유효한 날짜인지 검증하고 있음.
      if (userStore.$isValidYyyyMMddByNewDate(localpageDate)){
        datepicker.value = new Date(`${localpageDate.substring(0, 4)}-${localpageDate.substring(4, 6)}-${localpageDate.substring(6, 8)}`);
        syncDateSelectBoxesFromDate(datepicker.value);
      } else {
        alert("특정 지면 바로가기 링크의 지면 날짜가 정확하지 않습니다. \n현재 날짜 지면을 불러옵니다. \n확인 후 다시 시도해 주시기 바랍니다. ");
        userStore.localpageSerial = '';
        getPublicationDate(datepicker.value);
      }
    }

    await initMobileDateSelectBoxes();

    window.addEventListener('resize', ()=>handleResize());
    document.documentElement.style.setProperty('--hilight-color', userStore.searchHiColor);// 키워드 하이라이트 색상을 css통해 버튼 색으로 반영하기 위함.

    if(userStore.$showFeature('scrap')) await showScrapList();// 북마크 사용 권한이 한 개의 매체라도 있는 경우 북마크 데이터 불러오기
    if(scrapData.value[0]) selectedScrapGroupSeq.value = scrapData.value[0].seq;// 북마크 그룹 선택 상태 초기화.

    userStore.$showFeature('tts');


  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
    window.removeEventListener('keydown', handleKey);
    const button = document.querySelector('#alignmentControlBtn');
    // `resizeObserver` 해제
    if (resizeObserver) resizeObserver.disconnect();
  });

// -----------------------------------------------------------------------------------------------------------------------------------------------------
  function DrawerOptionChange(option){
    if(tab.value===option) {
      tab.value = '';
      nestedDrawer.value = false;
    } else {
      tab.value = option;
      if(tab.value == 'option-5') { // 정보 탭 클릭 시에는 좌측 사이드바 열리지 않도록.
        nestedDrawer.value = false;
        return;
      }
      nestedDrawer.value = true;
    }
  }

  function openNotionInformation(){
    window.open('https://www.notion.so/2219a9a5802f807eb676c8813cfc7b79', '_blank');
  }
  // ---------------------------------------------------------------------------------------------------------------------------------------------------
</script>

<style scoped>
@import '@/assets/css/user/pretendard.css';

/* 모바일 헤더 내 아이콘 버튼 크기 조정 */
::v-deep(header.mobile-header .v-btn--icon.v-btn--density-default){
    width: calc(var(--v-btn-height));
    height: calc(var(--v-btn-height));
    margin: 0 8px 0 0;
}

/* 달력 버튼 */
::v-deep(header.mobile-header #calendarBtn.v-btn--size-default) {
    font-size: 12px !important;
    font-weight: 600 !important;
    padding: 0 8px !important;
    margin: 0 8px;
}
::v-deep(header.mobile-header #calendarBtn .v-btn__content) {gap:0px !important;}
::v-deep(header.mobile-header .v-app-bar-nav-icon) {
  margin: 0px !important
}
/* 모바일에서 아이콘이 너무 쭈그러지지 않도록.*/
::v-deep(header.mobile-header .header-logo) {
  flex: 0 0 auto !important;   /* shrink 금지 + 자동 크기 */
  flex-shrink: 0 !important;   /* 이것만 있어도 효과 큼 */
  min-width: 55% !important;   /* “너무 작아짐” 확실히 방지 */
}
.calendar-btn-fixed {
  position: relative;
  min-width: 170px; /* 날짜 텍스트 길이 기준. 현재 포맷 yyyy-MM-dd (E) */
}
.calendar-btn-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.calendar-btn-content-hidden {
  visibility: hidden;
}
.calendar-btn-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.btn-click-blocked {
  cursor: default;
}

/* 헤더 영역 분할*/
/* PC: 좌(메뉴버튼+로고버튼)/중(달력버튼)/우(나머지 버튼) 3구역, 모바일: 좌(메뉴버튼+로고버튼)/우(달력버튼+나머지버튼) 2구역(각 50%) */
#header .header-wrap{
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0; /* flex overflow/ellipsis에 중요 */
}
#header .header-left,
#header .header-center,
#header .header-right{
  display: flex;
  align-items: center;
  min-width: 0;
}
#header .header-left{
  flex: 0 0 auto;
}
/* PC: 가운데 캘린더 */
#header:not(.mobile-header) .header-center{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
#header:not(.mobile-header) .header-right{
  flex: 0 0 auto;
  margin-left: auto;
  justify-content: flex-end;
  gap: 4px;
}
/* 모바일: 좌/우 정확히 50% */
#header .header-left{
  flex: 0 1 40%;
  max-width: 40%;
  overflow: hidden;
}
#header .header-left.without-logo-button{
  flex: 0 1 10% !important;
  max-width: 10% !important;
}
#header .header-right{
  flex: 0 1 50%;
  max-width: 50%;
  overflow: hidden;
  justify-content: flex-end;
}
#header.mobile-header .header-right{
  flex: 0 1 60% !important;
  max-width: 60% !important;
  justify-content: flex-end;
}
#header.mobile-header .header-right.without-logo-button{
  flex: 0 1 90% !important;
  max-width: 90% !important;
}

/* right 안의 버튼/메뉴는 줄어들지 않게(아이콘 찌그러짐 방지) */
#header .header-right > *{
  flex: 0 0 auto;
}
/* /헤더 영역 분할*/

/* 모바일 - 날짜 셀렉트 박스css */
#header.mobile-header .date-select-box-wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  margin-right: 0px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.date-select-item {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
}
.date-select-item :deep(.v-field) {
  padding-right: 0 !important;
}
.date-select-suffix {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}
.v-theme--darkTheme .date-select-suffix {
  color: #fff !important;
}
.date-select-box :deep(.v-field){
  grid-template-columns: unset !important;
  min-height: 28px !important;
  height: 28px !important;
}
.date-select-box :deep(.v-field__input) {
  flex: none;
  grid: none;
  min-height: 28px !important;
  padding : 0 0 0 4px !important;
  font-size: 12px;
  width: 95% !important
}
.year-select-box{
  width: 52px;
  min-width: 52px !important;
}
.day-select-box {
  width: 58px;
  min-width: 58px !important;
}
.day-select-box :deep(.v-field__input) { /* 셀렉트 박스 내부 화살표 아이콘 위치가 일자 값에 따라 흔들리지 않도록 조정 */
  min-width: 41px !important;
}
.month-select-box,
.page-select-box {
  width: 37px;
  min-width: 37px !important;
}
.month-select-box :deep(.v-field__input),
.page-select-box :deep(.v-field__input) { /* 셀렉트 박스 내부 화살표 아이콘 위치가 월/페이지 값에 따라 흔들리지 않도록 조정 */
  min-width: 19px !important;
}
.date-select-box :deep(.v-field__control) {
  grid-area: unset;
}
.date-select-box  {
  font-size: 14px;
  line-height: 28px;
  font-weight: 600;
}
.date-select-box :deep(.v-field__append-inner),
.date-select-box :deep(.v-field__clearable) {
  align-items: center;
  padding-top: 0 !important;
}
/* 화살표 회전 트랜지션 제거 및 화살표 영역 width가 24px → 14px로 조정 */
.date-select-box :deep(.v-field__append-inner) {
  width: 14px !important;
  min-width: 14px !important;
  display: flex;
  justify-content: center;
}
.date-select-box :deep(.v-field__append-inner .v-select__menu-icon) {
  width: 14px !important;
  margin: 0 !important;
  transform: none !important; /* 화살표 회전 트랜지션 제거 */
}
.date-select-box :deep(.v-field__append-inner .v-select__menu-icon::before) {
  width: 100%;
  text-align: center;
  display: block;
}
/* focus 시 테두리 두께 고정 (1px 유지) */
.date-select-box :deep(.v-field--focused .v-field__outline) {
  --v-field-border-width: 1px !important;
}
/* 날짜 셀렉트 박스 - 좌측 border 위아래 하얗게 보이는 현상 방지 */
.date-select-box :deep(.v-field--variant-outlined .v-field__outline__start),
.date-select-box :deep(.v-field--variant-outlined .v-field__outline__end) {
  border-radius: 0px !important;
}

/* 디자인 후속작업 적용*/
.v-theme--lightTheme .menutab{color: #3182f6;}
.v-theme--darkTheme .menutab{color: #fff;}

.mediaSel-menu-list.v-list-item--one-line {
  /* .v-list-item--one-line css 무효화 */
  padding-inline: inherit;

  /* .v-list-item--density-compact css가 적용되지 않아 여기서 내용 추가함. */
  min-height: 32px;
  /* 해당 css가 적용되지 않아 여기서 내용 추가함. */
  padding-left: 16px;
  padding-right: 16px;
}
.mediaSel-menu-list ::v-deep .v-list-item__content div {
  /* .v-list-item-title css 무효화 및 .text-subtitle-2 내용 추가 */

  /* 초기값으로 설정 */
  -webkit-hyphens: unset;
  hyphens: unset;
  overflow-wrap: unset;
  overflow: unset;
  padding: unset;
  white-space: unset;
  text-overflow: unset;
  word-break: unset;
  word-wrap: unset;

  /* .text-subtitle-2 내용 */
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  line-height: 1.375rem !important;
  letter-spacing: 0.0071428571em !important;
  font-family: "Pretendard", "Roboto", sans-serif;
  text-transform: none !important;
}

/* v-date-picker '오늘' 버튼 css */
.custom-today-btn {
  position: absolute;
  top: 20px;
  left: 177px;
  min-width: 40px;
  height: 30px !important;
}
.custom-today-btn.v-theme--lightTheme {
  color: rgb(102, 102, 102);
}
.custom-today-btn.v-theme--darkTheme {
  color: #fff;
}
.input-border-effect {
  border: 1px solid #ABABAB !important;
  border-radius: 4px;
  transition: border-color 0.5s ease;
}
.input-border-effect:hover,
.input-border-effect:focus {
  border-color: rgba(0, 0, 0, 0.87) !important;
}
/* 다크모드에서는 hover/focus 시에도 기본 색상 유지 */
.v-theme--darkTheme .input-border-effect:hover,
.v-theme--darkTheme .input-border-effect:focus {
  border-color: #ABABAB !important;
}

/* 자른 지면 북마크 생성여부 선택 모달창 내 v-combobox css */
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined .v-field__outline .v-field__outline__start) {
  border: 1px solid #ABABAB !important;
  border-right: none !important;
  opacity: 1;
  transition: border-color 0.5s ease;
}
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined:hover .v-field__outline .v-field__outline__start),
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__start) {
  border-color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined.v-theme--darkTheme:hover .v-field__outline .v-field__outline__start),
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined.v-theme--darkTheme.v-field--focused .v-field__outline .v-field__outline__start) {
  border-color: #ABABAB !important;
}
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined .v-field__outline .v-field__outline__end) {
  border: 1px solid #ABABAB !important;
  border-left: none !important;
  opacity: 1;
  transition: border-color 0.5s ease;
}
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined:hover .v-field__outline .v-field__outline__end),
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__end) {
  border-color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined.v-theme--darkTheme:hover .v-field__outline .v-field__outline__end),
::v-deep(.cuttingCanvas-title-input-border .v-field--variant-outlined.v-theme--darkTheme.v-field--focused .v-field__outline .v-field__outline__end) {
  border-color: #ABABAB !important;
}
::v-deep(.no-input-border input) {
  border: none !important;
  padding: 0px;
  font-size: 15px !important;
}

/* 테마변경 */
.v-theme--darkTheme .download-image-select-title {
  color: #fff;
}
.v-theme--darkTheme .cut-image-select-title {
  color: #fff;
}
/* 테마변경 버튼 아이콘 사용하기 + index.html에 link태그 추가. */
.material-symbols-outlined.themeBtn {
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}
.material-symbols-outlined.themeBtn.dark-mode {
  color: #666;
}
.material-symbols-outlined.themeBtn.light-mode {
  color: #999;
}
/* 단면/양면 변경 버튼 아이콘 사용하기 */
.material-symbols-outlined.pageSideBtn {
  font-variation-settings:
    'FILL' 0,
    'wght' 100,
    'GRAD' 0,
    'opsz' 12,
}

.v-theme--lightTheme .material-symbols-outlined.pageSideBtn {
  color: #666;
}
.v-theme--darkTheme .material-symbols-outlined.pageSideBtn {
  color: #999;
}

/* '기능 더보기' 버튼 관련 css */
/* id="colorPickerBtn-web",
  id="colorPicker-web" 색상에 대한 css는
  origin_style.css에서 변경하고 있음.
*/
#colorPicker-web {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5000;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
#colorPickerBtn-web {
  z-index: 4999;
}
#colorPicker-mobile {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5000;
  width: 100%;
  height: 100%;

  opacity: 0;
  cursor: pointer;
}
#colorPickerBtn-mobile {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4999;
  width: 36px;
  height: 36px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  border: none;
  border-radius: 50%;
}
#moreFuncBtnMenu ::v-deep div.v-overlay__content {
  left: unset !important;
  right: 8px !important;
}
.v-theme--lightTheme .kebab.mdi:before{color: #666; align-items: center;}
.v-theme--darkTheme .kebab.mdi:before{color: #fff; align-items: center;}

/* 선/면자르기 작업창 내 버튼 css */
.cutting-tool-btn {
  width: 105px;
  height: 36px !important;
  font-size: 14px;
  box-sizing: border-box;
  border: none !important;
}
::v-deep(.cutting-tool-btn .v-btn__prepend .mdi:before){
  color: white;
}

.top-box,
.bottom-box {
  height: 50px;
  background-color: #e0e0e0;
}

.side-box {
  height: 839px;
  background-color: #f5f5f5;
}

.content-box {
  height: 839px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.iframe-box {
  width: 100%;
  height: 811px;
}



</style>
